import React, { useState, memo, useMemo,useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useClientHeader } from './ClientHeaderContext';
import { useHamburgerMenu } from '../../../../Contexts/HamburgerMenuContext';
import UserService from '../../../../Services/user.service';
import EnumsService from '../../../../Services/enums.service';
import Button from '@mui/material/Button';
import '../../ClientDetails.css';
import Select from 'react-select';
import { TextField, Tooltip, Modal, Box, Typography, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Paper, InputAdornment, Checkbox, Autocomplete, Popper } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import ExcelJournalImportModal from './ExcelJournalImportModal';
import ExcelAccountCardsImportModal from './ExcelAccountCardsImportModal';
import RivhitCsvImportModal from './RivhitCsvImportModal';
import AccountIndexImportModal from './AccountIndexImportModal';
import RivhitClosingBalanceImportModal from './RivhitClosingBalanceImportModal';
import RamplusAccountCardsImportModal from './RamplusAccountCardsImportModal';
import RamplusJournalImportModal from './RamplusJournalImportModal';
import RamplusClosingBalanceImportModal from './RamplusClosingBalanceImportModal';
import SumitClosingBalanceImportModal from './SumitClosingBalanceImportModal';
import FinbotClosingBalanceImportModal from './FinbotClosingBalanceImportModal';
import SumitAccountCardsImportModal from './SumitAccountCardsImportModal';
import SumitJournalImportModal from './SumitJournalImportModal';
import FinbotAccountCardsImportModal from './FinbotAccountCardsImportModal';
import FinbotJournalImportModal from './FinbotJournalImportModal';
import PaperlessImportModal from './PaperlessImportModal';
import RavginitJournalImportModal from './RavginitJournalImportModal';
import BmkvdJournalImportModal from './BmkvdJournalImportModal';
import AtzmaitCsvImportModal from './AtzmaitCsvImportModal';
import WebenefitJournalImportModal from './WebenefitJournalImportModal';
import AtzmaitBackupImportModal from '../../../AtzmaitBackupImport/AtzmaitBackupImportModal';
import RivhitBackupImportModal from '../../../RivhitBackupImport/RivhitBackupImportModal';
import KodBenaAccountCardsImportModal from './KodBenaAccountCardsImportModal';
import KodBenaJournalImportModal from './KodBenaJournalImportModal';
import TaiodetAccountCardsImportModal from './TaiodetAccountCardsImportModal';
import TaiodetJournalImportModal from './TaiodetJournalImportModal';
import PriorityAccountCardsImportModal from './PriorityAccountCardsImportModal';
import PriorityJournalImportModal from './PriorityJournalImportModal';
import PriorityOpeningBalanceImportModal from './PriorityOpeningBalanceImportModal';
import AccountCardPkudaExportModal from './AccountCardPkudaExportModal';
import DownloadUniformFile from '../../../Widgets/DownloadUniformFile/DownloadUniformFile';
import Constants from '../../../../assests/Constants/constants';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import { calculateVatAmount, getVatValue } from "../../../../Utils/GetVatValue";
import PCNChecksSummary from '../../../PCN/PCNChecksSummary';
import PCNChecksAccordion from '../../../PCN/PCNChecksAccordion';
import { useTranslation } from 'react-i18next';
import PCNModal from '../../../PCN/PCNModal';
import PCNChecksModal from '../../../PCN/PCNChecksModal';
import DropzoneArea from '../DropzoneArea';
import TutorialVideosModal from '../../../Widgets/TutorialVideosModal/TutorialVideosModal';
import MdbMissingAccountCardsTable from './MdbMissingAccountCardsTable';
import MoveinDatImportModal from './MoveinDatImportModal';
import HeshinAccountCardsImportModal from './HeshinAccountCardsImportModal';
import HypDocIncomeImportModal from './HypDocIncomeImportModal';
import IcountMoveinDatImportModal from './IcountMoveinDatImportModal';
import MorningIncomesImportModal from './MorningIncomesImportModal';
import MdbImportModal from './MdbImportModal';
import MorningPaymentsImportModal from './MorningPaymentsImportModal';
import MorningApiImportModal from './MorningApiImportModal';
import MavenImportModal from './MavenImportModal';
import ICountImportModal from './ICountImportModal';
import EasyCountImportModal from './EasyCountImportModal';
import VerifoneImportModal from './VerifoneImportModal';
import XtramJournalImportModal from './XtramJournalImportModal';
import ImportExportService from '../../../../Services/importExport.service';
const BorderBoxButton = styled(Button)({
    boxSizing: 'border-box !important',
});

const PkudaSortCodeStyledPopper = styled(Popper)(({ theme }) => ({
    zIndex: 9999,
    '& .MuiPaper-root': {
        borderRadius: '8px',
        background: '#FFF',
        boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.15)',
        minWidth: '200px',
    },
    '& .MuiAutocomplete-listbox': {
        padding: theme.spacing(1),
        maxHeight: '280px',
    },
    '& .MuiAutocomplete-option': {
        borderRadius: '4px',
        padding: '8px 12px',
        fontSize: '0.875rem',
        margin: '2px 0',
        '&[aria-selected="true"]': {
            background: 'rgba(48, 79, 255, 0.12) !important',
            fontWeight: 600,
        },
        '&.Mui-focused': {
            background: 'rgba(249, 170, 42, 0.15) !important',
        },
        '&:hover': {
            background: 'rgba(249, 170, 42, 0.25) !important',
        },
    },
}));

// Helper functions for document type display



const getBeforeVatAmount = (doc) => {
    
    const vat = calculateVatAmount(doc.amount,  doc.vat, doc.documentDate);
    return doc.amount - vat;
  };

  
// Reusable styled button component for modals
const StyledModalButton = ({ onClick, children, sx = {} }) => (
    <Box
        component="button"
        className="download-modal-button"
        onClick={onClick}
        sx={{
            width: '80%',
            p: '16px 20px',
            mb: '20px',
            background: 'white',
            border: '2px solid #E5E7EB',
            borderRadius: '12px',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            alignSelf: 'center',
            boxSizing: 'border-box',
            fontSize: '16px',
            fontWeight: 600,
            color: '#1A1A1A',
            '&:hover': {
                borderColor: '#304FFF',
                background: '#F8F9FF',
                transform: 'translateX(-2px)'
            },
            ...sx
        }}
    >
        {children}
    </Box>
);

const DownloadImportModals = memo(function DownloadImportModals() {
    const { t } = useTranslation();
    const { handleDocumentRowClick } = useHamburgerMenu();
    const location = useLocation();
    const client = location?.state?.client;
    
    const {
        // Show/hide flags
        showDownloadModal, closeDownloadModal,
        showDownloadFilesModal, closeFileDownloadModal,
        showExportJournalModal, closeExportJournal,
        showImportModal, closeImportModal,
        showImportJournalModal, closeImportJournal,
        showAccountCardModal, closeAccountCardModal,
        showAccountCardImportModal, closeAccountCardImportModal,
        showHeshinDatModal, setShowHeshinDatModal,
        showJEImportModal, setShowJEImportModal,
        showRivhitImportModal, setShowRivhitImportModal,

        // Modal openers/handlers
        openExportModal,
        openAccountCardModal,
        openAccountCardImportModal,
        openImportModal,
        openRivhitEntriesImportModal,
        openJournalEntriesImportModal,
        openReferenceSequenceModal,

        // Download/upload handlers
        downloadVATReport,
        downloadWithholdingTaxReport,
        downloadPCNReport,
        handlePCNDownload,
        handlePCNChecks,
        downloadProfitAndLoss,
        journalEntryDownload,
        journalEntryDownloadMovein,
        showMoveinExportPreview,
        setShowMoveinExportPreview,
        moveinExportPreviewData,
        moveinSortCodeMappings,
        setMoveinSortCodeMappings,
        confirmMoveinExport,
        journalEntryDownloadPkuda,
        showPkudaExportPreview,
        setShowPkudaExportPreview,
        pkudaExportPreviewData,
        pkudaExportOptions,
        setPkudaExportOptions,
        refreshPkudaExportPreview,
        confirmPkudaExport,
        accountantCardDownload,
        accountantCardDownloadHeshin,
        accountantCardDownloadPkuda,
        showAccountCardExportPreview,
        setShowAccountCardExportPreview,
        accountCardExportPreviewData,
        editableAccountCards,
        setEditableAccountCards,
        confirmAccountCardExport,

        // File refs & upload handlers
        fileInputRef1,
        handleFileButtonClick,
        uploadFileToAccountCardRevhit,

        // Heshin/Movein file handlers
        handleHeshinDatDrop,
        handleHeshinPrmDrop,
        heshinDatFile,
        heshinPrmFile,
        handleHeshinDatUpload,
        handleDateChangeNew,
        handleStartDateChangeNew,
        handleEndDateChangeNew,
        handleBiMonthDate,

        // MoveIn file handlers
        moveInDatFile,
        handleMoveInDatDrop,
        handleMoveInDatUpload,
        moveInDatAmountDivisor,
        setMoveInDatAmountDivisor,
        handleRangeChange,

        // --- Date Pickers (journal entry) ---
        CustomMonthDatePicker,
        setJeStartDate,
        setJeEndDate,
        jeStartDate,
        jeEndDate,

        // Utilities/components
        dayjs,

        // Icons/images
        backIcon,

        // UI/Localization
        direction,

        showAtzmaitImportModal, setShowAtzmaitImportModal,
        handleAtzmaitCsvDrop, atzmaitCsvFile, setAtzmaitCsvFile,
        previewAtzmaitCsv, commitAtzmaitCsv,
        missingSortCodes, setMissingSortCodes, createMissingSortCodes,
        formattedSortCodeVatType,
        formattedSortCodesGroupNamesOptions,
        previewPkuda,
        commitPkuda,
        pkudaMissingSortCodes,
        setPkudaMissingSortCodes,

        importMdbAccountCards,
        importMdbJournalEntries,
        previewMdbJournal,
        commitMdbJournal,
        previewExcelJournal,
        commitExcelJournal,
        previewExcelAccountCards,
        commitExcelAccountCards,
        createMissingPalCode,
        palCodeCategoryOptions,
        palCodes,
        user,
        token,
        
        // Rivhit CSV V2 Import handlers
        previewRivhitCsvV2,
        commitRivhitCsvV2,

        // Rivhit Closing Balance Import handlers
        previewRivhitClosingBalance,
        commitRivhitClosingBalance,
        // Ramplus Import handlers
        previewRamplusAccountCards,
        commitRamplusAccountCards,
        previewRamplusJournal,
        commitRamplusJournal,
        previewRamplusClosingBalance,
        commitRamplusClosingBalance,
        previewSumitClosingBalance,
        commitSumitClosingBalance,
        previewFinbotClosingBalance,
        commitFinbotClosingBalance,
        
        // Sumit Import handlers
        previewSumitAccountCards,
        commitSumitAccountCards,
        previewSumitJournal,
        commitSumitJournal,
        // Finbot Import handlers
        previewFinbotAccountCards,
        commitFinbotAccountCards,
        previewFinbotJournal,
        commitFinbotJournal,
        // Finbot API Import handlers
        fetchFinbotClients,
        previewFinbotJournalApi,
        commitFinbotJournalApi,
        previewFinbotAccountCardsApi,
        commitFinbotAccountCardsApi,
        // Paperless API Import handlers — one call imports both cards and journal entries
        fetchPaperlessUsers,
        previewPaperlessApi,
        commitPaperlessApi,
        createMissingSortCodeCategory,

        // Ravginit (RAVGONIT .26) Import handlers — journal import also creates account cards
        previewRavginitJournal,
        commitRavginitJournal,

        // Uniform file (BKMVDATA.txt) Import handlers — journal import also creates account cards
        previewBmkvdJournal,
        commitBmkvdJournal,

        // Account index (אינדקס חשבונות Excel) Import handlers
        previewRavginitAccountIndex,
        commitRavginitAccountIndex,
        previewNihulitAccountIndex,
        commitNihulitAccountIndex,

        // Webenefit Import handlers
        previewWebenefitJournal,
        commitWebenefitJournal,

        // קוד בינה Import handlers
        previewKodBenaAccountCards,
        commitKodBenaAccountCards,
        previewKodBenaJournal,
        commitKodBenaJournal,
        
        // Taiodet Import handlers
        previewTaiodetAccountCards,
        commitTaiodetAccountCards,
        previewTaiodetJournal,
        commitTaiodetJournal,
        
        // Priority Import handlers
        previewPriorityAccountCards,
        commitPriorityAccountCards,
        previewPriorityJournal,
        commitPriorityJournal,
        previewPriorityOpeningBalance,
        commitPriorityOpeningBalance,
        
        // PCN Modal
        showPCNModal, setShowPCNModal,
        pcnIncludeStornoChecks, setPcnIncludeStornoChecks,
        showPCNChecksModal, setShowPCNChecksModal,
        pcnHighConfirmationDocs, setPcnHighConfirmationDocs,
        pcnChecksLoading, setPcnChecksLoading,
        pcnDocumentsNeedingAllocation, setPcnDocumentsNeedingAllocation,
        pcnDocumentsWithoutReference, setPcnDocumentsWithoutReference,
        pcnDocumentsOutOfRange, setPcnDocumentsOutOfRange,
        pcnReportDetails, setPcnReportDetails,
        sortCodeOptions = [],

    } = useClientHeader();

    const [pkudaFiles, setPkudaFiles] = useState([]);
    const [pkudaWorkbookFile, setPkudaWorkbookFile] = useState(null);
    const [pkudaPreviewDone, setPkudaPreviewDone] = useState(false);
    const [pkudaProcessing, setPkudaProcessing] = useState(false);
    const [pkudaEditableMissing, setPkudaEditableMissing] = useState([]);
    const [pkudaSelectedRows, setPkudaSelectedRows] = useState([]);
    const [pkudaBulkVatType, setPkudaBulkVatType] = useState(null);
    const [pkudaBulkGroup, setPkudaBulkGroup] = useState(null);
    const [pkudaBulkPar, setPkudaBulkPar] = useState(null);
    const [pkudaBulkVat, setPkudaBulkVat] = useState(null);
    const [pkudaMappings, setPkudaMappings] = useState([]);
    const [pkudaPreviewData, setPkudaPreviewData] = useState(null);
    const [pkudaPreviewSearch, setPkudaPreviewSearch] = useState('');
    const [pkudaPreviewPage, setPkudaPreviewPage] = useState(0);
    const [pkudaPreviewRowsPerPage, setPkudaPreviewRowsPerPage] = useState(25);
    const [pkudaSkipDuplicates, setPkudaSkipDuplicates] = useState(true);
    const [pkudaMissingAccountCards, setPkudaMissingAccountCards] = useState([]);

    /* Tutorial Videos Modal */
    const [showTutorialVideosModal, setShowTutorialVideosModal] = useState(false);

    /* MDB local state */
    const [showMdbModal, setShowMdbModal] = useState(false);
    const [mdbMode, setMdbMode] = useState('cards'); // 'cards' or 'journal'
    const [accountCardOptions, setAccountCardOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    
    // Excel journal entry import modal state
    const [showExcelJournalModal, setShowExcelJournalModal] = useState(false);
    const [showExcelAccountCardsModal, setShowExcelAccountCardsModal] = useState(false);
    
    // Rivhit CSV V2 import modal state
    const [showRivhitCsvV2Modal, setShowRivhitCsvV2Modal] = useState(false);

    // Ramplus modals
    const [showRamplusAccountCardsModal, setShowRamplusAccountCardsModal] = useState(false);
    const [showRamplusJournalModal, setShowRamplusJournalModal] = useState(false);
    const [showRamplusClosingBalanceModal, setShowRamplusClosingBalanceModal] = useState(false);

    // Rivhit Closing Balance import modal state
    const [showRivhitClosingBalanceModal, setShowRivhitClosingBalanceModal] = useState(false);
    const [showSumitClosingBalanceModal, setShowSumitClosingBalanceModal] = useState(false);
    const [showFinbotClosingBalanceModal, setShowFinbotClosingBalanceModal] = useState(false);
    
    // Sumit import modal state
    const [showSumitAccountCardsModal, setShowSumitAccountCardsModal] = useState(false);
    const [showSumitJournalModal, setShowSumitJournalModal] = useState(false);

    // Finbot import modal state
    const [showFinbotAccountCardsModal, setShowFinbotAccountCardsModal] = useState(false);
    const [showFinbotJournalModal, setShowFinbotJournalModal] = useState(false);

    // Paperless import modal state (one modal for both cards and journal entries)
    const [showPaperlessModal, setShowPaperlessModal] = useState(false);

    // Ravginit (RAVGONIT .26) import modal state
    const [showRavginitJournalModal, setShowRavginitJournalModal] = useState(false);

    // Uniform file (BKMVDATA.txt) journal import modal state
    const [showBmkvdJournalModal, setShowBmkvdJournalModal] = useState(false);

    // Account index (אינדקס חשבונות Excel) import modal state
    const [showRavginitAccountIndexModal, setShowRavginitAccountIndexModal] = useState(false);
    const [showNihulitAccountIndexModal, setShowNihulitAccountIndexModal] = useState(false);

    // Webenefit import modal state
    const [showWebenefitJournalModal, setShowWebenefitJournalModal] = useState(false);
    const [showAtzmaitBackupModal, setShowAtzmaitBackupModal] = useState(false);
    const [showRivhitBackupModal, setShowRivhitBackupModal] = useState(false);

    // קוד בינה import modal state
    const [showKodBenaAccountCardsModal, setShowKodBenaAccountCardsModal] = useState(false);
    const [showKodBenaJournalModal, setShowKodBenaJournalModal] = useState(false);
    
    // Taiodet import modal state
    const [showTaiodetAccountCardsModal, setShowTaiodetAccountCardsModal] = useState(false);
    const [showTaiodetJournalModal, setShowTaiodetJournalModal] = useState(false);
    
    // Priority import modal state
    const [showPriorityAccountCardsModal, setShowPriorityAccountCardsModal] = useState(false);
    const [showPriorityJournalModal, setShowPriorityJournalModal] = useState(false);
    const [showPriorityOpeningBalanceModal, setShowPriorityOpeningBalanceModal] = useState(false);
    
    // BMKVD (Uniform File) modal state
    const [showUniformFileModal, setShowUniformFileModal] = useState(false);

    // HypDoc Income and iCount Movein.DAT import modal state
    const [showHypDocIncomeModal, setShowHypDocIncomeModal] = useState(false);
    const [showIcountMoveinDatModal, setShowIcountMoveinDatModal] = useState(false);
    const [showMorningIncomesModal, setShowMorningIncomesModal] = useState(false);
    const [showMorningPaymentsModal, setShowMorningPaymentsModal] = useState(false);
    const [showMorningApiImportModal, setShowMorningApiImportModal] = useState(false);
    const [showMavenModal, setShowMavenModal] = useState(false);
    const [showICountCsvModal, setShowICountCsvModal] = useState(false);
    const [showEasyCountCsvModal, setShowEasyCountCsvModal] = useState(false);
    const [showVerifoneModal, setShowVerifoneModal] = useState(false);
    const [showXtramJournalModal, setShowXtramJournalModal] = useState(false);
    

    const [isDateRange, setIsDateRange] = useState(false); // New state variable
    const [date, setDate] = useState(dayjs());
    const [startDate, setStartDate] = useState(dayjs());
    const [endDate, setEndDate] = useState(dayjs());
    const handleStartReferenceYearDate = async (date) => {
        setDate(date);
    }


    const resetPkudaState = useCallback(() => {
        setPkudaFiles([]);
        setPkudaWorkbookFile(null);
        setPkudaPreviewDone(false);
        setPkudaProcessing(false);
        setPkudaEditableMissing([]);
        setPkudaSelectedRows([]);
        setPkudaBulkVatType(null);
        setPkudaBulkGroup(null);
        setPkudaBulkPar(null);
        setPkudaBulkVat(null);
        setPkudaMappings([]);
        setPkudaMissingSortCodes([]);
        setPkudaMissingAccountCards([]);
        setPkudaPreviewData(null);
    }, [setPkudaMissingSortCodes]);


    useEffect(() => {
        if (!showRivhitImportModal) {
            resetPkudaState();
        }
    }, [showRivhitImportModal, resetPkudaState]);

    useEffect(() => {
        setPkudaPreviewDone(false);
        setPkudaProcessing(false);
        setPkudaEditableMissing([]);
        setPkudaSelectedRows([]);
        setPkudaBulkVatType(null);
        setPkudaBulkGroup(null);
        setPkudaBulkPar(null);
        setPkudaBulkVat(null);
        setPkudaMappings([]);
        setPkudaMissingSortCodes([]);
        setPkudaMissingAccountCards([]);
        setPkudaPreviewData(null);
    }, [pkudaFiles, pkudaWorkbookFile, setPkudaMissingSortCodes]);

    const setWithholdingTaxTypeFunc = (type) => {
        if (type === 'monthlyReport') {
            setIsDateRange(true);
        }
        else {
            setIsDateRange(false);
        }
    }

    // Wrapper function to pass modal dates to handlePCNDownload
    const handlePCNDownloadWithModalDates = async () => {
        // Create a temporary setDates function for the modal context
        const setDates = (isRange, date, startDate, endDate) => {
            if (isRange) {
                return { start: startDate, end: endDate };
            } else {
                return { start: date, end: date };
            }
        };

        // Get the dates from the modal state
        const { start, end } = setDates(isDateRange, date, startDate, endDate);
        
        // Call the original handlePCNDownload with the modal dates
        await handlePCNDownload(start, end);
    };

    // Wrapper function to pass modal dates to handlePCNChecks
    const handlePCNChecksWithModalDates = async () => {
        // Create a temporary setDates function for the modal context
        const setDates = (isRange, date, startDate, endDate) => {
            if (isRange) {
                return { start: startDate, end: endDate };
            } else {
                return { start: date, end: date };
            }
        };

        // Get the dates from the modal state
        const { start, end } = setDates(isDateRange, date, startDate, endDate);
        
        // Call the original handlePCNChecks with the modal dates
        await handlePCNChecks(start, end);
    };
    const normalizePkudaMissing = useCallback((missing) => (
        (missing ?? []).map(sc => ({
            ...sc,
            sortCodeName: sc.sortCodeName?.trim() ? sc.sortCodeName : 'ללא שם',
            sortCodeVatType: sc.sortCodeVatType ?? null,
            sortCodeGroup: sc.sortCodeGroup ?? null,
            participatesInProfitAndLoss:
                typeof sc.participatesInProfitAndLoss === 'boolean'
                    ? sc.participatesInProfitAndLoss
                    : null,
            vat: typeof sc.vat === 'number' ? sc.vat : null,
        }))
    ), []);



    const closePkudaModal = () => {
        resetPkudaState();
        setShowRivhitImportModal(false);
    };

    const handlePkudaFilesDrop = (files) => {
        if (!files) return;

        const incoming = Array.isArray(files)
            ? files
            : Array.from(files);

        if (!incoming.length) return;

        setPkudaFiles(prev => {
            const existingKeys = new Set(prev.map(f => `${f.name}-${f.lastModified}`));
            const next = [...prev];

            incoming.forEach(file => {
                if (!file) return;

                const key = `${file.name}-${file.lastModified}`;
                if (!existingKeys.has(key)) {
                    existingKeys.add(key);
                    next.push(file);
                }
            });

            return next;
        });
    };

    const handlePkudaWorkbookDrop = (files) => {
        setPkudaWorkbookFile(files && files.length ? files[0] : null);
    };

    const removePkudaFile = (fileToRemove) => {
        setPkudaFiles(prev => prev.filter(file => file !== fileToRemove));
    };
 
    const handlePkudaPreview = async () => {
        if (!pkudaFiles.length) return;
 
         try {
             setPkudaProcessing(true);
 
             const res = await previewPkuda(pkudaFiles, pkudaWorkbookFile);
             const missing = res?.missingSortCodes ?? [];
             const normalized = normalizePkudaMissing(missing);
 
             setPkudaMissingSortCodes(missing);
             setPkudaEditableMissing(normalized);
             setPkudaMappings(res?.sortCodeMappings ?? []);
             setPkudaMissingAccountCards(res?.missingAccountCards ?? []);
             setPkudaPreviewData({
                 entries: res?.entries ?? [],
                 totalLines: res?.parsedRows ?? 0,
                 validCount: res?.validCount ?? 0,
                 errorCount: res?.errorCount ?? 0,
                 duplicateCount: res?.duplicateCount ?? 0,
                 errorMessages: res?.errorMessages ?? [],
                 detectedFormat: res?.detectedFormat ?? null,
                 accountManagementWarning: res?.accountManagementWarning ?? null,
             });
             setPkudaPreviewPage(0);
             setPkudaPreviewSearch('');
             setPkudaPreviewDone(true);
         } catch (err) {
             console.error('Preview PKUDA failed:', err);
             setPkudaPreviewDone(false);
         } finally {
             setPkudaProcessing(false);
         }
     };

    const handlePkudaCreateAndCommit = async () => {
        if (!pkudaFiles.length) return;

        try {
            setPkudaProcessing(true);

            if (pkudaEditableMissing && pkudaEditableMissing.length > 0) {
                await createMissingSortCodes(pkudaEditableMissing);
                
                // Wait for database to commit all sortcodes (500ms delay)
                await new Promise(resolve => setTimeout(resolve, 500));
            }

            await commitPkuda(pkudaFiles, pkudaWorkbookFile, pkudaSkipDuplicates);
            closePkudaModal();
        } catch (err) {
            console.error('Create & Commit PKUDA error:', err);
        } finally {
            setPkudaProcessing(false);
        }
    };

    const updatePkudaMissing = (index, field, value) =>
        setPkudaEditableMissing(prev => {
            const arr = [...prev];
            arr[index] = { ...arr[index], [field]: value };
            return arr;
        });

    const applyPkudaBulk = () => {
        setPkudaEditableMissing(prev =>
            prev.map(r =>
                pkudaSelectedRows.includes(r.sortCodeId)
                    ? {
                        ...r,
                        sortCodeVatType: pkudaBulkVatType?.value ?? r.sortCodeVatType,
                        sortCodeGroup: pkudaBulkGroup?.value ?? r.sortCodeGroup,
                        participatesInProfitAndLoss:
                            pkudaBulkPar?.value ?? r.participatesInProfitAndLoss,
                        vat: pkudaBulkVat?.value ?? r.vat,
                    }
                    : r
            )
        );
        setPkudaSelectedRows([]);
        setPkudaBulkVatType(null);
        setPkudaBulkGroup(null);
        setPkudaBulkPar(null);
        setPkudaBulkVat(null);
    };
 
    const pkudaMissingIncomplete = useMemo(
        () => pkudaEditableMissing.some(sc =>
            !sc.sortCodeName?.trim() ||
             sc.sortCodeVatType === null || sc.sortCodeVatType === undefined ||
            sc.participatesInProfitAndLoss === null ||
            sc.participatesInProfitAndLoss === undefined ||
            sc.vat === null ||
            sc.vat === undefined
        ),
        [pkudaEditableMissing]
    );

    const formatPkudaAccountDisplay = (id, name) => {
        if (!id && !name) return '—';
        if (id && name) return `${id} (${name})`;
        return id || name || '—';
    };

    const formatPkudaSortCodeDisplay = (id, name) => {
        if (!id && !name) return '—';
        if (id && name) return `${id} (${name})`;
        return id || name || '—';
    };

    const pkudaPreviewEntries = pkudaPreviewData?.entries ?? [];
    const pkudaFilteredEntries = useMemo(() => {
        if (!pkudaPreviewSearch.trim()) return pkudaPreviewEntries;
        const term = pkudaPreviewSearch.trim().toLowerCase();
        return pkudaPreviewEntries.filter(row =>
            [row.debitAccount, row.debitAccountName, row.creditAccount, row.creditAccountName,
             row.description, row.reference, row.sortCodeId, row.sortCodeName, row.documentDate,
             row.sourceFile, String(row.amount ?? '')]
                .some(val => val && String(val).toLowerCase().includes(term))
        );
    }, [pkudaPreviewEntries, pkudaPreviewSearch]);

    const pkudaPaginatedEntries = useMemo(() =>
        pkudaFilteredEntries.slice(
            pkudaPreviewPage * pkudaPreviewRowsPerPage,
            pkudaPreviewPage * pkudaPreviewRowsPerPage + pkudaPreviewRowsPerPage
        ), [pkudaFilteredEntries, pkudaPreviewPage, pkudaPreviewRowsPerPage]);

    const pkudaFormatAmount = (amount) => {
        if (amount == null) return '';
        return new Intl.NumberFormat('he-IL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
    };

    const pkudaPreviewSummaries = useMemo(() => {
        const valid = pkudaPreviewEntries.filter(e => e.isValid && !(e.isDuplicate && pkudaSkipDuplicates));
        const sumAmount = valid.reduce((s, e) => s + (Number(e.amount) || 0), 0);
        const sumDebit = valid.filter(e => e.debitAccount).reduce((s, e) => s + (Number(e.amount) || 0), 0);
        const sumCredit = valid.filter(e => e.creditAccount).reduce((s, e) => s + (Number(e.amount) || 0), 0);
        let sumNet = 0;
        let sumVat = 0;
        valid.forEach(e => {
            const amt = Number(e.amount) || 0;
            const vatPct = e.vat != null ? Number(e.vat) : 0;
            if (vatPct > 0) {
                const net = amt / (1 + vatPct / 100);
                sumNet += net;
                sumVat += amt - net;
            } else {
                sumNet += amt;
            }
        });
        return { sumAmount, sumDebit, sumCredit, sumNet, sumVat };
    }, [pkudaPreviewEntries, pkudaSkipDuplicates]);

    // Shared fetchEnums function for account card options
    const fetchEnums = async (currentUser, currentToken, currentClient) => {
        const targetUser = currentUser || user;
        const targetToken = currentToken || token;
        const targetClient = currentClient || client;
        
        if (targetClient && targetToken) {
            try {
                setLoading(true);
                const accountsResponse = await EnumsService.GetAccountCardsByCaseId(targetClient.caseId, targetToken);
                if (accountsResponse.ok) {
                    const accountsData = await accountsResponse.json();
                    const accountCardOptions = [{ name: t('AddAccountCard'), value1: 'AddItem' }, ...accountsData];
                    setAccountCardOptions(accountCardOptions);
                }
            } catch (error) {
                console.error('Error fetching account cards:', error);
            } finally {
                setLoading(false);
            }
        }
    };

    // Handle document row click to send to hamburger menu
    const handleDocumentRowClickInDownloadImportModals = (doc) => {
        // Send document information to hamburger menu for processing
        if (doc && handleDocumentRowClick) {
            // Call the hamburger menu callback with document ID and document type
            handleDocumentRowClick(doc.id, doc.documentType);
        } else {
            console.warn('onDocumentRowClick is not available or doc is missing:', { doc, handleDocumentRowClickInDownloadImportModals });
        }
    };

 
    

    const customStyles = {
        container: (provided) => ({
            ...provided,
            width: '100%',
            boxSizing: 'border-box !important'
        }),
        control: (provided) => ({
            ...provided,
            minHeight: '40px',
            width: '100% !important',
            borderRadius: '8px',
            background: '#F5F5F6',
            border: 'none',
            boxShadow: 'none',
            padding: '0 10px',
            textAlign: 'left',
            boxSizing: 'border-box !important',
            border: '1px solid transparent',
            '&:focus-within': {
                border: '2px solid var(--Foundation-Blue-Normal, #304FFF)',
            },
        }),
        placeholder: (provided) => ({
            ...provided,
            textAlign: 'left',
            color: 'black'
        }),
        singleValue: (provided) => ({
            ...provided,
            textAlign: 'left',
            color: 'black',
        }),
        menu: (provided) => ({
            ...provided,
            textAlign: 'left',
            color: 'black',
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? '#F9AA2A'
                : state.isFocused
                    ? '#ebebeb'
                    : null,
            color: 'black',
        }),
        dropdownIndicator: (provided, state) => ({
            ...provided,
            color: state.isFocused ? 'darkgray' : 'black',
            '&:hover': {
                color: 'darkgray',
            },
        }),
        menuPortal: (provided) => ({
            ...provided,
            zIndex: 2002,
        }),
    };
    return (
        <>
            {showDownloadModal && (
                <div className="download-modal-overlay" onClick={closeDownloadModal}>
                    <div className="download-modal" onClick={(e) => e.stopPropagation()}>
                        <div className={`download-modal-content ${direction}`} style={{ position: 'relative' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                                <h4 className="report-title">{t('SelectFileType')}</h4>
                                <IconButton 
                                    className="client-back-icon" 
                                    onClick={closeDownloadModal}
                                    sx={{ padding: '4px' }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </div>
                            <div className="download-modal-buttons-container">
                                <StyledModalButton onClick={openExportModal}>
                                    {t('Export Journal Entry File')}
                                </StyledModalButton>
                                <StyledModalButton onClick={openAccountCardModal}>
                                    {t('Export Account Card Files')}
                                </StyledModalButton>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {showImportModal && (
                <div className="download-modal-overlay" onClick={closeImportModal}>
                    <div className="download-modal" onClick={(e) => e.stopPropagation()}>
                        <div className={`download-modal-content ${direction}`} style={{ position: 'relative' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                                <h4 className="report-title">{t('SelectFileType')}</h4>

                                <IconButton 
                                    className="client-back-icon" 
                                    onClick={closeImportModal}
                                    sx={{ padding: '4px' }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </div>

                            <div className="download-modal-buttons-container">
                                <StyledModalButton 
                                    onClick={() => setShowTutorialVideosModal(true)}
                                    sx={{ gap: '8px' }}
                                >
                                    <Box
                                        component="span"
                                        sx={{
                                            fontSize: '16px',
                                            fontWeight: 600,
                                            color: '#1A1A1A',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px'
                                        }}
                                    >
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
                                            <path d="M8 5V19L19 12L8 5Z" fill="#304FFF"/>
                                            <circle cx="12" cy="12" r="11" stroke="#304FFF" strokeWidth="2" fill="none"/>
                                        </svg>
                                        {t('TutorialVideos')}
                                    </Box>
                                    <Box
                                        component="span"
                                        sx={{
                                            width: '8px',
                                            height: '8px',
                                            borderRadius: '50%',
                                            background: 'linear-gradient(135deg, #304FFF 0%, #F9AA2A 100%)',
                                            boxShadow: '0 2px 8px rgba(48, 79, 255, 0.4)',
                                            flexShrink: 0
                                        }}
                                    />
                                </StyledModalButton>
                                <StyledModalButton onClick={openAccountCardImportModal}>
                                    {t('ImportAccountCardFiles')}
                                </StyledModalButton>
                                <StyledModalButton onClick={openImportModal}>
                                    {t('ImportJournalEntries')}
                                </StyledModalButton>

                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showDownloadFilesModal && (
                <div className="download-modal-overlay" onClick={closeFileDownloadModal}>
                    <div className="download-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="download-modal-content" style={{ position: 'relative' }}>
                            <IconButton 
                                className="client-back-icon" 
                                style={{ position: 'absolute', top: '0px', left: '-10px', margin: '0px' }} 
                                onClick={closeFileDownloadModal}
                                sx={{ padding: '4px' }}
                            >
                                <CloseIcon />
                            </IconButton>
                            <h4 className="report-title">{t('selectReportType')}</h4>
                            <div className="download-modal-buttons-container">
                                {[
                                    { onClick: downloadVATReport, text: t('VATReport') },
                                    { onClick: downloadWithholdingTaxReport, text: t('AdvancesReport') },
                                    { onClick: downloadPCNReport, text: t('PCNFile') },
                                    { onClick: handlePCNChecks, text: t('Checks') },
                                    { onClick: downloadProfitAndLoss, text: t('ProfitAndLossReport') },
                                    { onClick: openReferenceSequenceModal, text: t('ReferenceSequence') }
                                ].map((btn, idx) => (
                                    <StyledModalButton key={idx} onClick={btn.onClick}>
                                        {btn.text}
                                    </StyledModalButton>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {showExportJournalModal && (
                <div className="download-modal-overlay" onClick={closeExportJournal}>
                    <div className="download-modal" onClick={(e) => e.stopPropagation()}>
                        <div className={`download-modal-content ${direction}`} style={{ position: 'relative' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                                <h4 className="report-title">{t('Export Journal Entry File')}</h4>

                                <IconButton 
                                    className="client-back-icon" 
                                    onClick={closeExportJournal}
                                    sx={{ padding: '4px' }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </div>
                            {/* <div className='add-document-input-container '>
                                <div className='edit-checkBox-field'>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-form-control-label-placement"
                                        name="position"
                                        defaultValue="top"
                                        onChange={(e) => setFileType(e.target.value)}
                                    >
                                        
                                        <FormControlLabel
                                            value="TXT"
                                            control={<Radio />}
                                            label={"TXT קובץ"}
                                            labelPlacement="top"
                                        />
                                    </RadioGroup>
                                </div>
                            </div> */}

                            <CustomMonthDatePicker
                                onDateChange={(date) => setJeStartDate(date)}
                                date={jeStartDate}
                                label={t('StartDate')}
                                height="55px"
                            />
                            <div style={{ margin: '10px' }} />
                            <CustomMonthDatePicker
                                onDateChange={(date) => setJeEndDate(date)}
                                date={jeEndDate}
                                label={t('EndDate')}
                                style={{ margin: '10px' }}
                                height="55px"
                            />
                            <div style={{ margin: '10px' }} />



                            <StyledModalButton onClick={() => journalEntryDownloadPkuda()}>
                                PKUDA - פקודת יומן
                            </StyledModalButton>
                            <StyledModalButton onClick={() => journalEntryDownloadMovein()}>
                                Movein.dat
                            </StyledModalButton>
                            <StyledModalButton onClick={() => setShowUniformFileModal(true)}>
                                קובץ אחיד - BMKVD
                            </StyledModalButton>

                            {/* <button className="download-modal-button-old" onClick={() => journalEntryDownload('Yearly')}>{"חשבשבת"}</button> */}

                        </div>
                    </div>
                </div>
            )}


            {showImportJournalModal && (
                <div className="download-modal-overlay" onClick={closeImportJournal}>
                    <div className="download-modal" onClick={(e) => e.stopPropagation()}>
                        <div className={`download-modal-content ${direction}`} style={{ position: 'relative' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                                <h4 className="report-title">{t('ImportJournalEntryFile')}</h4>

                                <IconButton 
                                    className="client-back-icon" 
                                    onClick={closeImportJournal}
                                    sx={{ padding: '4px' }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </div>

                            <StyledModalButton onClick={openRivhitEntriesImportModal}>
                                ריווחית-PKUDA / כרטסת
                            </StyledModalButton>
                            <StyledModalButton onClick={() => setShowRivhitBackupModal(true)}>
                                ריווחית-גיבוי ZIP
                            </StyledModalButton>
                            <StyledModalButton onClick={() => setShowRamplusJournalModal(true)}>
                                רם פלוס - פקודות יומן
                            </StyledModalButton>
                            <StyledModalButton onClick={openJournalEntriesImportModal}>
                                Movein.dat
                            </StyledModalButton>
                            <StyledModalButton onClick={() => setShowAtzmaitImportModal(true)}>
                                עצמאית-CSV
                            </StyledModalButton>
                            <StyledModalButton onClick={() => setShowAtzmaitBackupModal(true)}>
                                עצמאית-גיבוי ZIP
                            </StyledModalButton>
                            <StyledModalButton onClick={() => { setMdbMode('journal'); setShowMdbModal(true); }}>
                                {"חשבשבת"}-MDB
                            </StyledModalButton>

                            <StyledModalButton onClick={() => { setShowExcelJournalModal(true); }}>
                                {"חשבשבת"}-יתרת פתיחה Excel
                            </StyledModalButton>

                            <StyledModalButton onClick={() => setShowSumitJournalModal(true)}>
                                Sumit - פקודות יומן
                            </StyledModalButton>

                            <StyledModalButton onClick={() => setShowFinbotJournalModal(true)}>
                                Finbot - פקודות יומן
                            </StyledModalButton>

                            <StyledModalButton onClick={() => setShowPaperlessModal(true)}>
                                Paperless - יומן וכרטיסים
                            </StyledModalButton>

                            <StyledModalButton onClick={() => setShowRavginitJournalModal(true)}>
                                {t('RavginitImportJournalButton')}
                            </StyledModalButton>

                            <StyledModalButton onClick={() => setShowWebenefitJournalModal(true)}>
                                Webenefit - פקודות יומן
                            </StyledModalButton>

                            <StyledModalButton onClick={() => setShowKodBenaJournalModal(true)}>
                                קוד בינה - פקודות יומן
                            </StyledModalButton>

                            <StyledModalButton onClick={() => setShowTaiodetJournalModal(true)}>
                                Taiodet - פקודות יומן
                            </StyledModalButton>

                            <StyledModalButton onClick={() => setShowPriorityJournalModal(true)}>
                                Priority - פקודות יומן
                            </StyledModalButton>

                            <StyledModalButton onClick={() => setShowPriorityOpeningBalanceModal(true)}>
                                Priority - יתרת פתיחה
                            </StyledModalButton>

                            <StyledModalButton onClick={() => setShowRivhitClosingBalanceModal(true)}>
                                 ריווחית - יתרת סגירה
                            </StyledModalButton>

                            <StyledModalButton onClick={() => setShowRamplusClosingBalanceModal(true)}>
                                רם פלוס - יתרת סגירה
                            </StyledModalButton>

                            <StyledModalButton onClick={() => setShowSumitClosingBalanceModal(true)}>
                                Sumit - מאזן בוחן (יתרת סגירה)
                            </StyledModalButton>

                            <StyledModalButton onClick={() => setShowFinbotClosingBalanceModal(true)}>
                                Finbot - מאזן בוחן (יתרת סגירה)
                            </StyledModalButton>

                            <StyledModalButton onClick={() => setShowHypDocIncomeModal(true)}>
                                Hyp - הכנסות (קובץ doc)
                            </StyledModalButton>

                            {/* <StyledModalButton onClick={() => setShowIcountMoveinDatModal(true)}>
                                iCount - הכנסות (קובץ dat)
                            </StyledModalButton> */}

                            <StyledModalButton onClick={() => setShowMorningIncomesModal(true)}>
                                Morning - הכנסות (קובץ csv)
                            </StyledModalButton>

                            <StyledModalButton onClick={() => setShowMorningPaymentsModal(true)}>
                                Morning - תשלומים (קובץ csv)
                            </StyledModalButton>

                            <StyledModalButton onClick={() => setShowMorningApiImportModal(true)}>
                                {t('MorningApiImportButton')}
                            </StyledModalButton>

                            <StyledModalButton onClick={() => setShowMavenModal(true)}>
                                Maven (קובץ Excel)
                            </StyledModalButton>

                            <StyledModalButton onClick={() => setShowICountCsvModal(true)}>
                                iCount – CSV (חשבוניות / תקבולים / זיכויים / לקוחות)
                            </StyledModalButton>

                            <StyledModalButton onClick={() => setShowEasyCountCsvModal(true)}>
                                EasyCount – CSV (לקוחות / דוח מסמכים)
                            </StyledModalButton>

                            <StyledModalButton onClick={() => setShowVerifoneModal(true)}>
                                Verifone – מסוף אשראי (קובץ Excel)
                            </StyledModalButton>

                            <StyledModalButton onClick={() => setShowXtramJournalModal(true)}>
                                Xtram פקודות יומן (קובץ Excel)
                            </StyledModalButton>

                            <StyledModalButton
                                onClick={() => {
                                    closeImportJournal();
                                    setShowBmkvdJournalModal(true);
                                }}
                            >
                                {t('BmkvdImportJournalButton')}
                            </StyledModalButton>
                        </div>
                    </div>
                </div>
            )}

            {/* ------------------------------ EXCEL JOURNAL ENTRY MODAL ------------------------------ */}
            <ExcelJournalImportModal
                open={showExcelJournalModal}
                onClose={() => setShowExcelJournalModal(false)}
                previewExcelJournal={previewExcelJournal}
                commitExcelJournal={commitExcelJournal}
                direction={direction}
                t={t}
            />

            {/* ------------------------------ RIVHIT CLOSING BALANCE MODAL ------------------------------ */}
            <RivhitClosingBalanceImportModal
                open={showRivhitClosingBalanceModal}
                onClose={() => setShowRivhitClosingBalanceModal(false)}
                previewRivhitClosingBalance={previewRivhitClosingBalance}
                commitRivhitClosingBalance={commitRivhitClosingBalance}
                direction={direction}
                t={t}
            />

            {/* ------------------------------ SUMIT CLOSING BALANCE MODAL ------------------------------ */}
            <SumitClosingBalanceImportModal
                open={showSumitClosingBalanceModal}
                onClose={() => setShowSumitClosingBalanceModal(false)}
                previewSumitClosingBalance={previewSumitClosingBalance}
                commitSumitClosingBalance={commitSumitClosingBalance}
                createMissingPalCode={createMissingPalCode}
                palCodeCategoryOptions={palCodeCategoryOptions || []}
                palCodes={palCodes || []}
                Constants={Constants}
                user={user}
                direction={direction}
                t={t}
            />

            {/* ------------------------------ FINBOT CLOSING BALANCE MODAL ------------------------------ */}
            <FinbotClosingBalanceImportModal
                open={showFinbotClosingBalanceModal}
                onClose={() => setShowFinbotClosingBalanceModal(false)}
                previewFinbotClosingBalance={previewFinbotClosingBalance}
                commitFinbotClosingBalance={commitFinbotClosingBalance}
                createMissingPalCode={createMissingPalCode}
                palCodeCategoryOptions={palCodeCategoryOptions || []}
                palCodes={palCodes || []}
                Constants={Constants}
                user={user}
                direction={direction}
                t={t}
            />

            {/* ------------------------------ EXCEL ACCOUNT CARDS MODAL ------------------------------ */}
            <ExcelAccountCardsImportModal
                open={showExcelAccountCardsModal}
                onClose={() => setShowExcelAccountCardsModal(false)}
                previewExcelAccountCards={previewExcelAccountCards}
                commitExcelAccountCards={commitExcelAccountCards}
                createMissingPalCode={createMissingPalCode}
                direction={direction}
                t={t}
                palCodeCategoryOptions={palCodeCategoryOptions || []}
                palCodes={palCodes || []}
                Constants={Constants}
                user={user || {}}
            />

            <AtzmaitCsvImportModal
                open={showAtzmaitImportModal}
                onClose={() => setShowAtzmaitImportModal(false)}
                file={atzmaitCsvFile}
                onFileDrop={handleAtzmaitCsvDrop}
                onFileReset={() => setAtzmaitCsvFile(null)}
                previewAtzmaitCsv={previewAtzmaitCsv}
                commitAtzmaitCsv={commitAtzmaitCsv}
                createMissingSortCodes={createMissingSortCodes}
                setMissingSortCodes={setMissingSortCodes}
                formattedSortCodeVatType={formattedSortCodeVatType || []}
                formattedSortCodesGroupNamesOptions={formattedSortCodesGroupNamesOptions || []}
                direction={direction}
                t={t}
            />
            {showAccountCardModal && (
                <div className="download-modal-overlay" onClick={closeAccountCardModal}>
                    <div className="download-modal" onClick={(e) => e.stopPropagation()}>
                        <div className={`download-modal-content ${direction}`} style={{ position: 'relative' }}>

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                                <h4 className="report-title">{t('Export Account Card Files')}</h4>

                                <IconButton 
                                    className="client-back-icon" 
                                    onClick={closeAccountCardModal}
                                    sx={{ padding: '4px' }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </div>

                            {/* <StyledModalButton onClick={() => accountantCardDownload()}>
                                ריווחית
                            </StyledModalButton> */}
                            <StyledModalButton onClick={() => accountantCardDownloadPkuda()}>
                                PKUDA - כרטיסי חשבון
                            </StyledModalButton>
                            <StyledModalButton onClick={() => accountantCardDownloadHeshin()}>
                                heshin.dat+prm
                            </StyledModalButton>

                            {/* <button className="download-modal-button-old" onClick={() => accountantCardDownload()}>{"חשבשבת"}</button> */}
                        </div>
                    </div>
                </div>
            )}



            {showAccountCardImportModal && (
                <div className="download-modal-overlay" onClick={closeAccountCardImportModal}>
                    <div className="download-modal" onClick={(e) => e.stopPropagation()}>
                        <div className={`download-modal-content ${direction}`} style={{ position: 'relative' }}>

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                                <h4 className="report-title">{t('ImportAccountCardFiles')}</h4>

                                <IconButton 
                                    className="client-back-icon" 
                                    onClick={closeAccountCardImportModal}
                                    sx={{ padding: '4px' }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </div>
                            <input
                                type="file"
                                ref={fileInputRef1}
                                style={{ display: 'none' }} // Hide the file input
                            />
                            {/* <StyledModalButton onClick={() => handleFileButtonClick(fileInputRef1, uploadFileToAccountCardRevhit)}>
                                ריווחית אינדקס מקוצר-csv (V1)
                            </StyledModalButton> */}
                            <StyledModalButton onClick={() => setShowRivhitCsvV2Modal(true)}>
                            ריווחית אינדקס מקוצר-csv 
                            </StyledModalButton>
                            <StyledModalButton onClick={() => setShowRamplusAccountCardsModal(true)}>
                                {t('ImportRamplusAccountCards') || 'רם פלוס - כרטיסי חשבון'}
                            </StyledModalButton>
                            <StyledModalButton onClick={() => setShowRavginitAccountIndexModal(true)}>
                                {t('ImportRavginitAccountIndex') || 'רבגונית - אינדקס חשבונות (Excel)'}
                            </StyledModalButton>
                            <StyledModalButton onClick={() => setShowNihulitAccountIndexModal(true)}>
                                {t('ImportNihulitAccountIndex') || 'ניהולית - אינדקס חשבונות (Excel)'}
                            </StyledModalButton>
                            <StyledModalButton onClick={() => setShowHeshinDatModal(true)}>
                                Heshin.Dat
                            </StyledModalButton>
                            <StyledModalButton onClick={() => { setMdbMode('cards'); setShowMdbModal(true); }}>
                                {"חשבשבת"}-MDB
                            </StyledModalButton>
                            <StyledModalButton onClick={() => setShowExcelAccountCardsModal(true)}>
                                {"חשבשבת"}-Excel
                            </StyledModalButton>

                            <StyledModalButton onClick={() => setShowSumitAccountCardsModal(true)}>
                                Sumit - כרטיסי חשבון
                            </StyledModalButton>

                            <StyledModalButton onClick={() => setShowFinbotAccountCardsModal(true)}>
                                Finbot - כרטיסי חשבון
                            </StyledModalButton>

                            <StyledModalButton onClick={() => setShowKodBenaAccountCardsModal(true)}>
                                קוד בינה - כרטיסי חשבון
                            </StyledModalButton>

                            <StyledModalButton onClick={() => setShowTaiodetAccountCardsModal(true)}>
                                Taiodet - כרטיסי חשבון
                            </StyledModalButton>

                            <StyledModalButton onClick={() => setShowPriorityAccountCardsModal(true)}>
                                Priority - כרטיסי חשבון
                            </StyledModalButton>
                        </div>
                    </div>
                </div>
            )}
            {showMdbModal && (
                <MdbImportModal
                    open={showMdbModal}
                    onClose={() => setShowMdbModal(false)}
                    mode={mdbMode}
                    direction={direction}
                    t={t}
                    client={client}
                    token={token}
                    user={user}
                    previewMdbJournal={previewMdbJournal}
                    commitMdbJournal={commitMdbJournal}
                    importMdbAccountCards={importMdbAccountCards}
                    createMissingSortCodes={createMissingSortCodes}
                    formattedSortCodeVatType={formattedSortCodeVatType}
                    formattedSortCodesGroupNamesOptions={formattedSortCodesGroupNamesOptions}
                    sortCodeOptions={sortCodeOptions}
                    accountCardOptions={accountCardOptions}
                    setAccountCardOptions={setAccountCardOptions}
                    palCodes={palCodes || []}
                    fetchEnums={fetchEnums}
                    setLoading={setLoading}
                />
            )}
            <HeshinAccountCardsImportModal
                open={showHeshinDatModal}
                onClose={() => setShowHeshinDatModal(false)}
                caseId={client?.caseId}
                token={token}
                onSuccess={() => {
                    setShowHeshinDatModal(false);
                    fetchEnums?.();
                }}
                previewHeshinAccountCards={ImportExportService.PreviewHeshinAccountCards}
                importHeshinAccountCards={ImportExportService.ImportHeshinAccountCards}
                t={t}
                direction={direction}
            />


            {showJEImportModal && (
                <MoveinDatImportModal
                    open={showJEImportModal}
                    onClose={() => setShowJEImportModal(false)}
                    caseId={client?.caseId}
                    token={token}
                    previewMovinDat={ImportExportService.PreviewMovinDat}
                    commitMovinDat={ImportExportService.ImportTransactionReportMovinDat}
                    onSuccess={() => setShowJEImportModal(false)}
                    t={t}
                    direction={direction}
                    sortCodeOptions={sortCodeOptions}
                    accountCardOptions={accountCardOptions}
                    fetchEnums={fetchEnums}
                    createMissingSortCodes={createMissingSortCodes}
                    formattedSortCodeVatType={formattedSortCodeVatType}
                    formattedSortCodesGroupNamesOptions={formattedSortCodesGroupNamesOptions}
                    Constants={Constants}
                />
            )}

            <HypDocIncomeImportModal
                open={showHypDocIncomeModal}
                onClose={() => setShowHypDocIncomeModal(false)}
                caseId={client?.caseId}
                accountantId={client?.accountantId}
                token={token}
                onSuccess={() => setShowHypDocIncomeModal(false)}
                previewHypDocIncome={ImportExportService.PreviewHypDocIncome}
                importHypDocIncome={ImportExportService.ImportHypDocIncome}
                sortCodeIdOptions={sortCodeOptions}
                accountCardOptions={accountCardOptions}
                client={client}
                palCodes={palCodes || []}
                fetchEnums={fetchEnums}
                setLoading={setLoading}
                setAccountCardOptions={setAccountCardOptions}
                t={t}
                direction={direction}
            />

            <IcountMoveinDatImportModal
                open={showIcountMoveinDatModal}
                onClose={() => setShowIcountMoveinDatModal(false)}
                caseId={client?.caseId}
                accountantId={client?.accountantId}
                token={token}
                onSuccess={() => setShowIcountMoveinDatModal(false)}
                previewIcountMoveinDat={ImportExportService.PreviewIcountMoveinDat}
                importIcountMoveinDat={ImportExportService.ImportIcountMoveinDat}
                sortCodeIdOptions={sortCodeOptions}
                accountCardOptions={accountCardOptions}
                client={client}
                palCodes={palCodes || []}
                fetchEnums={fetchEnums}
                setLoading={setLoading}
                setAccountCardOptions={setAccountCardOptions}
                t={t}
                direction={direction}
            />

            <MorningIncomesImportModal
                open={showMorningIncomesModal}
                onClose={() => setShowMorningIncomesModal(false)}
                caseId={client?.caseId}
                accountantId={client?.accountantId}
                token={token}
                onSuccess={() => setShowMorningIncomesModal(false)}
                previewMorningIncomes={ImportExportService.PreviewMorningIncomes}
                importMorningIncomes={ImportExportService.ImportMorningIncomes}
                sortCodeIdOptions={sortCodeOptions}
                accountCardOptions={accountCardOptions}
                client={client}
                palCodes={palCodes || []}
                fetchEnums={fetchEnums}
                setLoading={setLoading}
                setAccountCardOptions={setAccountCardOptions}
                t={t}
                direction={direction}
            />

            <MorningPaymentsImportModal
                open={showMorningPaymentsModal}
                onClose={() => setShowMorningPaymentsModal(false)}
                caseId={client?.caseId}
                accountantId={client?.accountantId}
                token={token}
                onSuccess={() => setShowMorningPaymentsModal(false)}
                previewMorningPayments={ImportExportService.PreviewMorningPayments}
                importMorningPayments={ImportExportService.ImportMorningPayments}
                sortCodeIdOptions={sortCodeOptions}
                accountCardOptions={accountCardOptions}
                client={client}
                palCodes={palCodes || []}
                fetchEnums={fetchEnums}
                setLoading={setLoading}
                setAccountCardOptions={setAccountCardOptions}
                t={t}
                direction={direction}
            />

            <MorningApiImportModal
                open={showMorningApiImportModal}
                onClose={() => setShowMorningApiImportModal(false)}
                caseId={client?.caseId}
                token={token}
                onSuccess={() => { if (fetchEnums) fetchEnums(); }}
                sortCodeIdOptions={sortCodeOptions}
                accountCardOptions={accountCardOptions}
                t={t}
                direction={direction}
            />

            <MavenImportModal
                open={showMavenModal}
                onClose={() => setShowMavenModal(false)}
                caseId={client?.caseId}
                accountantId={client?.accountantId}
                token={token}
                onSuccess={() => setShowMavenModal(false)}
                previewMavenDocuments={ImportExportService.PreviewMavenDocuments}
                importMavenDocuments={ImportExportService.ImportMavenDocuments}
                sortCodeIdOptions={sortCodeOptions}
                accountCardOptions={accountCardOptions}
                t={t}
                direction={direction}
            />

            <ICountImportModal
                open={showICountCsvModal}
                onClose={() => setShowICountCsvModal(false)}
                caseId={client?.caseId}
                accountantId={client?.accountantId}
                token={token}
                onSuccess={() => setShowICountCsvModal(false)}
                previewICountClients={ImportExportService.PreviewICountClients}
                importICountClients={ImportExportService.ImportICountClients}
                previewICountInvoices={ImportExportService.PreviewICountInvoices}
                importICountInvoices={ImportExportService.ImportICountInvoices}
                previewICountInvrec={ImportExportService.PreviewICountInvrec}
                importICountInvrec={ImportExportService.ImportICountInvrec}
                previewICountRefunds={ImportExportService.PreviewICountRefunds}
                importICountRefunds={ImportExportService.ImportICountRefunds}
                sortCodeIdOptions={sortCodeOptions}
                accountCardOptions={accountCardOptions}
                client={client}
                setAccountCardOptions={setAccountCardOptions}
                fetchEnums={fetchEnums}
                setLoading={setLoading}
                t={t}
                direction={direction}
            />

            <EasyCountImportModal
                open={showEasyCountCsvModal}
                onClose={() => setShowEasyCountCsvModal(false)}
                caseId={client?.caseId}
                accountantId={client?.accountantId}
                token={token}
                onSuccess={() => setShowEasyCountCsvModal(false)}
                previewEasyCountClients={ImportExportService.PreviewEasyCountClients}
                importEasyCountClients={ImportExportService.ImportEasyCountClients}
                previewEasyCountReport={ImportExportService.PreviewEasyCountReport}
                importEasyCountReport={ImportExportService.ImportEasyCountReport}
                sortCodeIdOptions={sortCodeOptions}
                accountCardOptions={accountCardOptions}
                client={client}
                setAccountCardOptions={setAccountCardOptions}
                fetchEnums={fetchEnums}
                t={t}
                direction={direction}
            />

            <VerifoneImportModal
                open={showVerifoneModal}
                onClose={() => setShowVerifoneModal(false)}
                caseId={client?.caseId}
                accountantId={client?.accountantId}
                token={token}
                onSuccess={() => setShowVerifoneModal(false)}
                previewVerifone={ImportExportService.PreviewVerifone}
                importVerifone={ImportExportService.ImportVerifone}
                sortCodeIdOptions={sortCodeOptions}
                accountCardOptions={accountCardOptions}
                client={client}
                setAccountCardOptions={setAccountCardOptions}
                t={t}
                direction={direction}
            />

            <XtramJournalImportModal
                open={showXtramJournalModal}
                onClose={() => setShowXtramJournalModal(false)}
                caseId={client?.caseId}
                accountantId={client?.accountantId}
                token={token}
                onSuccess={() => setShowXtramJournalModal(false)}
                previewXtramJournal={ImportExportService.PreviewXtramJournal}
                importXtramJournal={ImportExportService.ImportXtramJournal}
                t={t}
                direction={direction}
            />

            {showRivhitImportModal && (
                <div className="download-modal-overlay" onClick={closePkudaModal}>
                    <div className="download-modal" onClick={(e) => e.stopPropagation()}>
                        <div className={`download-modal-content ${direction}`} style={{ position: 'relative', maxWidth: pkudaPreviewData ? '1200px' : '600px' }}>

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                                <h4 className="report-title">{t('UploadRivhitFile')}</h4>

                                <IconButton 
                                    className="client-back-icon" 
                                    onClick={closePkudaModal}
                                    sx={{ padding: '4px' }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                                <div>
                                    <h5>{`${t('UploadFile')} (PKUDA .dat/.txt / כרטסת .csv)`}</h5>
                                    <DropzoneArea
                                        key={pkudaFiles.map(file => `${file.name}-${file.lastModified}`).join('|') || 'pkuda-empty'}
                                        onDrop={handlePkudaFilesDrop}
                                        accept=".dat,.txt,.csv"
                                        multiple
                                    />
                                    {pkudaFiles.length > 0 && (
                                        <ul className="pkuda-file-list">
                                            {pkudaFiles.map(file => (
                                                <li key={`${file.name}-${file.lastModified}`} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <span>{file.name}</span>
                                                    <Button size="small" variant="text" onClick={() => removePkudaFile(file)}>{t('Remove')}</Button>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>

                                <div>
                                    <h5>קודי מיון (.xls/.xlsx/.csv)</h5>
                                    <DropzoneArea
                                        key={pkudaWorkbookFile ? pkudaWorkbookFile.name : 'pkuda-workbook-empty'}
                                        onDrop={handlePkudaWorkbookDrop}
                                        accept=".xls,.xlsx,.csv"
                                        filesLimit={1}
                                    />
                                    {pkudaWorkbookFile && (
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 8 }}>
                                            <span>{t('FileSelected')}: {pkudaWorkbookFile.name}</span>
                                            <Button size="small" variant="text" onClick={() => setPkudaWorkbookFile(null)}>{t('Remove')}</Button>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div style={{ display: 'flex', gap: 15, marginTop: 20 }}>
                                <Button
                                    variant="contained"
                                    onClick={handlePkudaPreview}
                                    disabled={!pkudaFiles.length || pkudaProcessing}
                                >
                                    {t('Preview')}
                                </Button>
                                <Button
                                    variant="contained"
                                    color="success"
                                    disabled={!pkudaPreviewDone || pkudaProcessing || pkudaMissingIncomplete || pkudaMissingAccountCards.length > 0}
                                    onClick={handlePkudaCreateAndCommit}
                                >
                                    {pkudaProcessing ? t('Processing') : t('CreateAndImport')}
                                </Button>
                            </div>

                            {/* {pkudaMappings.length > 0 && (
                                <div style={{ marginTop: 20 }}>
                                    <h5>Detected sort-code mappings</h5>
                                    <ul style={{ paddingInlineStart: 20 }}>
                                        {pkudaMappings.map(({ originalSortCodeId, mappedSortCodeId }) => (
                                            <li key={`${originalSortCodeId}-${mappedSortCodeId}`}>
                                                {originalSortCodeId} → {mappedSortCodeId}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )} */}

                            {pkudaPreviewDone && pkudaPreviewData?.accountManagementWarning && (
                                <Box mt={2} p={1.5} bgcolor="#fff3e0" borderRadius={1} border="1px solid #ffb74d">
                                    <Typography variant="body2" color="warning.dark">
                                        {pkudaPreviewData.accountManagementWarning}
                                    </Typography>
                                </Box>
                            )}

                            {pkudaPreviewDone && (
                                <div style={{ marginTop: 25, maxHeight: 800, overflow: 'auto' }}>
                                    {pkudaEditableMissing.length === 0 ? (
                                        <div style={{ marginBottom: 25, padding: 15, backgroundColor: '#d4edda', borderRadius: 5, border: '1px solid #28a745' }}>
                                            <h5 style={{ color: '#155724', margin: '0 0 5px 0' }}>
                                                ✓ {t('NoMissingSortCodes') || 'אין קודי מיון חסרים'}
                                            </h5>
                                            <p style={{ fontSize: '14px', color: '#155724', margin: 0 }}>
                                                {t('ReadyToImportSortCodes') || 'כל קודי המיון קיימים. לחץ על "יצירה ויבוא" להמשך.'}
                                            </p>
                                        </div>
                                    ) : (
                                        <>
                                            <h5>{t('MissingSortCodes')}</h5>
                                            <Box display="flex" flexWrap="wrap" gap={1.5} alignItems="center" mb={2}>
                                                <Autocomplete
                                                    options={formattedSortCodeVatType || []}
                                                    getOptionLabel={(option) => option?.label ?? ''}
                                                    value={pkudaBulkVatType}
                                                    onChange={(e, newValue) => setPkudaBulkVatType(newValue)}
                                                    isOptionEqualToValue={(a, b) => a?.value === b?.value}
                                                    renderInput={(params) => (
                                                        <TextField {...params} placeholder={t('SelectSortCodeVatType')} size="small" />
                                                    )}
                                                    PopperComponent={PkudaSortCodeStyledPopper}
                                                    sx={{ minWidth: 180 }}
                                                />
                                                <Autocomplete
                                                    options={formattedSortCodesGroupNamesOptions || []}
                                                    getOptionLabel={(option) => option?.label ?? ''}
                                                    value={pkudaBulkGroup}
                                                    onChange={(e, newValue) => setPkudaBulkGroup(newValue)}
                                                    isOptionEqualToValue={(a, b) => a?.value === b?.value}
                                                    renderInput={(params) => (
                                                        <TextField {...params} placeholder={t('SelectSortCodeGroupName')} size="small" />
                                                    )}
                                                    PopperComponent={PkudaSortCodeStyledPopper}
                                                    sx={{ minWidth: 180 }}
                                                />
                                                <Autocomplete
                                                    options={[
                                                        { label: t('Yes'), value: true },
                                                        { label: t('No'), value: false },
                                                    ]}
                                                    getOptionLabel={(option) => option?.label ?? ''}
                                                    value={pkudaBulkPar}
                                                    onChange={(e, newValue) => setPkudaBulkPar(newValue)}
                                                    isOptionEqualToValue={(a, b) => a?.value === b?.value}
                                                    renderInput={(params) => (
                                                        <TextField {...params} placeholder={t('participatesInProfitAndLoss')} size="small" />
                                                    )}
                                                    PopperComponent={PkudaSortCodeStyledPopper}
                                                    sx={{ minWidth: 140 }}
                                                />
                                                <Autocomplete
                                                    options={Constants.VATPercentage.map((v) => ({ label: `${v}%`, value: v }))}
                                                    getOptionLabel={(option) => option?.label ?? ''}
                                                    value={pkudaBulkVat}
                                                    onChange={(e, newValue) => setPkudaBulkVat(newValue)}
                                                    isOptionEqualToValue={(a, b) => a?.value === b?.value}
                                                    renderInput={(params) => (
                                                        <TextField {...params} placeholder={t('VAT')} size="small" />
                                                    )}
                                                    PopperComponent={PkudaSortCodeStyledPopper}
                                                    sx={{ minWidth: 100 }}
                                                />
                                                <BorderBoxButton
                                                    variant="outlined"
                                                    disabled={!pkudaBulkVatType && !pkudaBulkGroup && !pkudaBulkPar && !pkudaBulkVat}
                                                    onClick={applyPkudaBulk}
                                                >
                                                    {t('ApplyToSelected')}
                                                </BorderBoxButton>
                                            </Box>
                                            <table className="sortcode-table editable">
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: '5%' }}>
                                                            <input
                                                                type="checkbox"
                                                                checked={pkudaSelectedRows.length === pkudaEditableMissing.length && pkudaEditableMissing.length > 0}
                                                                onChange={e =>
                                                                    setPkudaSelectedRows(
                                                                        e.target.checked
                                                                            ? pkudaEditableMissing.map(r => r.sortCodeId)
                                                                            : [],
                                                                    )
                                                                }
                                                            />
                                                        </th>
                                                        <th>{t('SortCode Id')}</th>
                                                        <th>{t('SortCode Name')}</th>
                                                        <th>{t('SelectSortCodeVatType')}</th>
                                                        <th>{t('SelectSortCodeGroupName')}</th>
                                                        <th>{t('participatesInProfitAndLoss')}</th>
                                                        <th>{t('VAT')}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {pkudaEditableMissing.map((sc, i) => (
                                                        <tr key={sc.sortCodeId}>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={pkudaSelectedRows.includes(sc.sortCodeId)}
                                                                    onChange={e =>
                                                                        setPkudaSelectedRows(prev =>
                                                                            e.target.checked
                                                                                ? [...prev, sc.sortCodeId]
                                                                                : prev.filter(id => id !== sc.sortCodeId),
                                                                        )
                                                                    }
                                                                />
                                                            </td>
                                                            <td>
                                                                <TextField
                                                                    fullWidth
                                                                    value={sc.sortCodeId}
                                                                    variant="standard"
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        disableUnderline: true,
                                                                        className: 'custom-box-sizing-border-box',
                                                                        sx: {
                                                                            height: '48px',
                                                                            padding: '0 10px',
                                                                            borderRadius: '8px',
                                                                            background: '#F5F5F6',
                                                                            border: '1px solid transparent',
                                                                        },
                                                                    }}
                                                                    inputProps={{
                                                                        style: {
                                                                            textAlign: direction === 'ltr' ? 'left' : 'right',
                                                                        },
                                                                    }}
                                                                />
                                                            </td>
                                                            <td>
                                                                <TextField
                                                                    fullWidth
                                                                    value={sc.sortCodeName ?? ''}
                                                                    variant="standard"
                                                                    onChange={e => updatePkudaMissing(i, 'sortCodeName', e.target.value)}
                                                                    placeholder={t('SortCode Name')}
                                                                    InputProps={{
                                                                        disableUnderline: true,
                                                                        className: 'custom-box-sizing-border-box',
                                                                        sx: {
                                                                            height: '48px',
                                                                            padding: '0 10px',
                                                                            borderRadius: '8px',
                                                                            background: '#fff',
                                                                            border: !sc.sortCodeName?.trim()
                                                                                ? '1.5px solid #f44336'
                                                                                : '1px solid #e0e0e0',
                                                                        },
                                                                    }}
                                                                    inputProps={{
                                                                        style: {
                                                                            textAlign: direction === 'ltr' ? 'left' : 'right',
                                                                        },
                                                                    }}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Autocomplete
                                                                    options={formattedSortCodeVatType || []}
                                                                    getOptionLabel={(option) => option?.label ?? ''}
                                                                    value={
                                                                        formattedSortCodeVatType.find(
                                                                            (opt) => opt.value === sc.sortCodeVatType?.toString()?.trim()
                                                                        ) || null
                                                                    }
                                                                    onChange={(e, newValue) =>
                                                                        updatePkudaMissing(i, 'sortCodeVatType', newValue?.value ?? null)
                                                                    }
                                                                    isOptionEqualToValue={(a, b) => a?.value === b?.value}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            {...params}
                                                                            placeholder={t('SelectSortCodeVatType')}
                                                                            size="small"
                                                                            error={sc.sortCodeVatType == null}
                                                                        />
                                                                    )}
                                                                    PopperComponent={PkudaSortCodeStyledPopper}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Autocomplete
                                                                    options={formattedSortCodesGroupNamesOptions || []}
                                                                    getOptionLabel={(option) => option?.label ?? ''}
                                                                    value={
                                                                        formattedSortCodesGroupNamesOptions.find((opt) => opt.value === sc.sortCodeGroup) ||
                                                                        null
                                                                    }
                                                                    onChange={(e, newValue) =>
                                                                        updatePkudaMissing(i, 'sortCodeGroup', newValue?.value ?? null)
                                                                    }
                                                                    isOptionEqualToValue={(a, b) => a?.value === b?.value}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            {...params}
                                                                            placeholder={t('SelectSortCodeGroupName')}
                                                                            size="small"
                                                                        />
                                                                    )}
                                                                    PopperComponent={PkudaSortCodeStyledPopper}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Autocomplete
                                                                    options={[
                                                                        { label: t('Yes'), value: true },
                                                                        { label: t('No'), value: false },
                                                                    ]}
                                                                    getOptionLabel={(option) => option?.label ?? ''}
                                                                    value={
                                                                        sc.participatesInProfitAndLoss === true
                                                                            ? { label: t('Yes'), value: true }
                                                                            : sc.participatesInProfitAndLoss === false
                                                                              ? { label: t('No'), value: false }
                                                                              : null
                                                                    }
                                                                    onChange={(e, newValue) =>
                                                                        updatePkudaMissing(i, 'participatesInProfitAndLoss', newValue?.value ?? null)
                                                                    }
                                                                    isOptionEqualToValue={(a, b) => a?.value === b?.value}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            {...params}
                                                                            placeholder={t('participatesInProfitAndLoss')}
                                                                            size="small"
                                                                            error={sc.participatesInProfitAndLoss == null}
                                                                        />
                                                                    )}
                                                                    PopperComponent={PkudaSortCodeStyledPopper}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Autocomplete
                                                                    options={Constants.VATPercentage.map((v) => ({ label: `${v}%`, value: v }))}
                                                                    getOptionLabel={(option) => option?.label ?? ''}
                                                                    value={
                                                                        Constants.VATPercentage.map((v) => ({ label: `${v}%`, value: v })).find(
                                                                            (opt) => opt.value === sc.vat
                                                                        ) || null
                                                                    }
                                                                    onChange={(e, newValue) => updatePkudaMissing(i, 'vat', newValue?.value ?? null)}
                                                                    isOptionEqualToValue={(a, b) => a?.value === b?.value}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            {...params}
                                                                            placeholder={t('VAT')}
                                                                            size="small"
                                                                            error={sc.vat == null}
                                                                        />
                                                                    )}
                                                                    PopperComponent={PkudaSortCodeStyledPopper}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </>
                                    )}
                                </div>
                            )}

                            {pkudaPreviewDone && pkudaMissingAccountCards.length > 0 && (
                                <Box mt={2.5}>
                                    <MdbMissingAccountCardsTable
                                        missingAccountCards={pkudaMissingAccountCards}
                                        direction={direction}
                                        client={client}
                                        token={token}
                                        palCodes={palCodes || []}
                                        accountCardOptions={accountCardOptions}
                                        fetchEnums={fetchEnums}
                                        setLoading={setLoading}
                                        isRange={false}
                                        isClosedReportingMonth={false}
                                        sortCodes={[]}
                                        user={user}
                                        setAccountCardOptions={setAccountCardOptions}
                                        onCardCreated={async () => {
                                            if (pkudaFiles.length) {
                                                await handlePkudaPreview();
                                            }
                                        }}
                                    />
                                </Box>
                            )}

                            {/* Preview Entries Table */}
                            {pkudaPreviewData && (
                                <Box mt={3} sx={{ maxHeight: 600, overflow: 'auto' }}>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                        {t('TotalLines')}: <strong>{pkudaPreviewData.totalLines}</strong>
                                        {' | '}
                                        {t('ValidCount')}: <strong>{pkudaPreviewData.validCount}</strong>
                                        {' | '}
                                        {t('ErrorCount')}: <strong>{pkudaPreviewData.errorCount}</strong>
                                        {(pkudaPreviewData.duplicateCount ?? 0) > 0 && (
                                            <>
                                                {' | '}
                                                <span style={{ color: '#ed6c02' }}>
                                                    {t('Duplicates')}: <strong>{pkudaPreviewData.duplicateCount}</strong>
                                                </span>
                                            </>
                                        )}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                                        {t('SumAmount')}: <strong>{pkudaFormatAmount(pkudaPreviewSummaries.sumAmount)}</strong>
                                        {' | '}
                                        {t('SumNetAmount')}: <strong>{pkudaFormatAmount(pkudaPreviewSummaries.sumNet)}</strong>
                                        {' | '}
                                        {t('SumVatAmount')}: <strong>{pkudaFormatAmount(pkudaPreviewSummaries.sumVat)}</strong>
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                        {t('SumDebit')}: <strong>{pkudaFormatAmount(pkudaPreviewSummaries.sumDebit)}</strong>
                                        {' | '}
                                        {t('SumCredit')}: <strong>{pkudaFormatAmount(pkudaPreviewSummaries.sumCredit)}</strong>
                                    </Typography>

                                    {(pkudaPreviewData.duplicateCount ?? 0) > 0 && (() => {
                                        const dupEntries = pkudaPreviewEntries.filter(e => e.isDuplicate);
                                        return (
                                            <Box mb={1.5}>
                                                <Box p={1} bgcolor="#fff3e0" borderRadius={1} border="1px solid #ffb74d" display="flex" alignItems="center" gap={1}>
                                                    <FormControlLabel
                                                        control={<Checkbox checked={pkudaSkipDuplicates} onChange={e => setPkudaSkipDuplicates(e.target.checked)} size="small" />}
                                                        label={<Typography variant="body2">{t('SkipDuplicateEntries')} ({pkudaPreviewData.duplicateCount} {t('Duplicates')})</Typography>}
                                                    />
                                                </Box>
                                                <Box mt={1} sx={{ maxHeight: 250, overflow: 'auto' }}>
                                                    <Typography variant="subtitle2" color="warning.dark" sx={{ mb: 0.5 }}>
                                                        {t('DuplicateEntries')} ({dupEntries.length})
                                                    </Typography>
                                                    <TableContainer component={Paper} variant="outlined" sx={{ bgcolor: '#fff8e1' }}>
                                                        <Table size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell sx={{ fontWeight: 700, fontSize: 11, py: 0.5, px: 1 }}>{t('Line')}</TableCell>
                                                                    <TableCell sx={{ fontWeight: 700, fontSize: 11, py: 0.5, px: 1 }}>{t('DocumentDate')}</TableCell>
                                                                    <TableCell sx={{ fontWeight: 700, fontSize: 11, py: 0.5, px: 1 }}>{t('DebitAccount')}</TableCell>
                                                                    <TableCell sx={{ fontWeight: 700, fontSize: 11, py: 0.5, px: 1 }}>{t('CreditAccount')}</TableCell>
                                                                    <TableCell align="right" sx={{ fontWeight: 700, fontSize: 11, py: 0.5, px: 1 }}>{t('Amount')}</TableCell>
                                                                    <TableCell sx={{ fontWeight: 700, fontSize: 11, py: 0.5, px: 1 }}>{t('Reference')}</TableCell>
                                                                    <TableCell sx={{ fontWeight: 700, fontSize: 11, py: 0.5, px: 1 }}>{t('Description')}</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {dupEntries.map((row, i) => (
                                                                    <TableRow key={i}>
                                                                        <TableCell sx={{ fontSize: 11, py: 0.3, px: 1 }}>{row.lineNumber}</TableCell>
                                                                        <TableCell sx={{ fontSize: 11, py: 0.3, px: 1, whiteSpace: 'nowrap' }}>{row.documentDate ?? '—'}</TableCell>
                                                                        <TableCell sx={{ fontSize: 11, py: 0.3, px: 1 }}>{formatPkudaAccountDisplay(row.debitAccount, row.debitAccountName)}</TableCell>
                                                                        <TableCell sx={{ fontSize: 11, py: 0.3, px: 1 }}>{formatPkudaAccountDisplay(row.creditAccount, row.creditAccountName)}</TableCell>
                                                                        <TableCell align="right" sx={{ fontSize: 11, py: 0.3, px: 1 }}>{pkudaFormatAmount(row.amount)}</TableCell>
                                                                        <TableCell sx={{ fontSize: 11, py: 0.3, px: 1 }}>{row.reference ?? '—'}</TableCell>
                                                                        <TableCell sx={{ fontSize: 11, py: 0.3, px: 1, maxWidth: 160, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={row.description}>{row.description ?? ''}</TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Box>
                                            </Box>
                                        );
                                    })()}

                                    <TextField
                                        size="small"
                                        placeholder={t('Search') || 'Search...'}
                                        value={pkudaPreviewSearch}
                                        onChange={e => { setPkudaPreviewSearch(e.target.value); setPkudaPreviewPage(0); }}
                                        sx={{ mb: 1.5, width: 320 }}
                                        InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> }}
                                    />

                                    {pkudaFilteredEntries.length > 0 && (
                                        <TableContainer component={Paper} variant="outlined" sx={{ overflowX: 'auto' }}>
                                            <Table size="small" stickyHeader>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell sx={{ fontWeight: 700, fontSize: 12 }}>{t('Line')}</TableCell>
                                                        <TableCell sx={{ fontWeight: 700, fontSize: 12 }}>{t('DocumentDate')}</TableCell>
                                                        <TableCell sx={{ fontWeight: 700, fontSize: 12 }}>{t('Reference')}</TableCell>
                                                        <TableCell sx={{ fontWeight: 700, fontSize: 12 }}>{t('DebitAccount')}</TableCell>
                                                        <TableCell sx={{ fontWeight: 700, fontSize: 12 }}>{t('CreditAccount')}</TableCell>
                                                        <TableCell align="right" sx={{ fontWeight: 700, fontSize: 12 }}>{t('Amount')}</TableCell>
                                                        <TableCell align="right" sx={{ fontWeight: 700, fontSize: 12 }}>{t('VAT')}</TableCell>
                                                        <TableCell sx={{ fontWeight: 700, fontSize: 12 }}>{t('SortCode Id')}</TableCell>
                                                        <TableCell sx={{ fontWeight: 700, fontSize: 12 }}>{t('Description')}</TableCell>
                                                        <TableCell sx={{ fontWeight: 700, fontSize: 12 }}>{t('Status')}</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {pkudaPaginatedEntries.map((row, i) => {
                                                        const hasMissing =
                                                            row.debitAccountMissing ||
                                                            row.creditAccountMissing ||
                                                            row.sortCodeMissing;
                                                        return (
                                                        <TableRow
                                                            key={row.lineNumber ?? i}
                                                            sx={{
                                                                bgcolor: hasMissing
                                                                    ? '#ffebee'
                                                                    : row.isDuplicate
                                                                        ? '#fff3e0'
                                                                        : row.isValid
                                                                            ? 'transparent'
                                                                            : 'action.hover',
                                                                opacity: row.isDuplicate && pkudaSkipDuplicates ? 0.5 : 1,
                                                                textDecoration: row.isDuplicate && pkudaSkipDuplicates ? 'line-through' : 'none',
                                                            }}
                                                        >
                                                            <TableCell sx={{ py: 0.5, px: 1, fontSize: 12 }}>{row.lineNumber}</TableCell>
                                                            <TableCell sx={{ py: 0.5, px: 1, fontSize: 12, whiteSpace: 'nowrap' }}>{row.documentDate ?? '—'}</TableCell>
                                                            <TableCell sx={{ py: 0.5, px: 1, fontSize: 12 }}>{row.reference ?? '—'}</TableCell>
                                                            <TableCell sx={{
                                                                py: 0.5, px: 1, fontSize: 12,
                                                                color: row.debitAccountMissing ? 'error.main' : 'inherit',
                                                                fontWeight: row.debitAccountMissing ? 600 : 400,
                                                                maxWidth: 200, whiteSpace: 'normal', wordBreak: 'break-word',
                                                            }}>
                                                                {formatPkudaAccountDisplay(row.debitAccount, row.debitAccountName)}
                                                            </TableCell>
                                                            <TableCell sx={{
                                                                py: 0.5, px: 1, fontSize: 12,
                                                                color: row.creditAccountMissing ? 'error.main' : 'inherit',
                                                                fontWeight: row.creditAccountMissing ? 600 : 400,
                                                                maxWidth: 200, whiteSpace: 'normal', wordBreak: 'break-word',
                                                            }}>
                                                                {formatPkudaAccountDisplay(row.creditAccount, row.creditAccountName)}
                                                            </TableCell>
                                                            <TableCell align="right" sx={{ py: 0.5, px: 1, fontSize: 12 }}>{pkudaFormatAmount(row.amount)}</TableCell>
                                                            <TableCell align="right" sx={{ py: 0.5, px: 1, fontSize: 12 }}>{row.vat != null ? `${Number(row.vat)}%` : '—'}</TableCell>
                                                            <TableCell sx={{
                                                                py: 0.5, px: 1, fontSize: 12,
                                                                color: row.sortCodeMissing ? 'error.main' : 'inherit',
                                                                fontWeight: row.sortCodeMissing ? 600 : 400,
                                                                maxWidth: 180, whiteSpace: 'normal', wordBreak: 'break-word',
                                                            }}>
                                                                {formatPkudaSortCodeDisplay(row.sortCodeId, row.sortCodeName)}
                                                            </TableCell>
                                                            <TableCell sx={{ py: 0.5, px: 1, fontSize: 12, maxWidth: 200, whiteSpace: 'normal', wordBreak: 'break-word' }} title={row.description}>{row.description ?? ''}</TableCell>
                                                            <TableCell sx={{ py: 0.5, px: 1, fontSize: 12, maxWidth: 280, whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                                                {row.isDuplicate ? (
                                                                    <Typography variant="body2" color="warning.main">{t('Duplicate')}</Typography>
                                                                ) : row.isValid ? (
                                                                    <Typography variant="body2" color="success.main">{t('Valid')}</Typography>
                                                                ) : (
                                                                    <Typography variant="body2" color="error.main" title={row.errorMessage}>{row.errorMessage ?? ''}</Typography>
                                                                )}
                                                            </TableCell>
                                                        </TableRow>
                                                        );
                                                    })}
                                                </TableBody>
                                            </Table>
                                            <TablePagination
                                                component="div"
                                                count={pkudaFilteredEntries.length}
                                                page={pkudaPreviewPage}
                                                onPageChange={(_, p) => setPkudaPreviewPage(p)}
                                                rowsPerPage={pkudaPreviewRowsPerPage}
                                                onRowsPerPageChange={e => { setPkudaPreviewRowsPerPage(parseInt(e.target.value, 10)); setPkudaPreviewPage(0); }}
                                                rowsPerPageOptions={[10, 25, 50, 100]}
                                                labelRowsPerPage={t('RowsPerPage')}
                                            />
                                        </TableContainer>
                                    )}
                                </Box>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* PKUDA Export Preview Modal */}
            {showPkudaExportPreview && pkudaExportPreviewData && (
                <div className="download-modal-overlay" onClick={() => setShowPkudaExportPreview(false)}>
                    <div className="download-modal" onClick={(e) => e.stopPropagation()}>
                        <div className={`download-modal-content ${direction}`} style={{ position: 'relative', maxWidth: '600px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                                <h4 className="report-title">תצוגה מקדימה - ייצוא PKUDA</h4>
                                <IconButton 
                                    className="client-back-icon" 
                                    onClick={() => setShowPkudaExportPreview(false)}
                                    sx={{ padding: '4px' }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </div>

                            {/* Export Type Selection - mix any combination */}
                            <Box sx={{ mb: 3 }}>
                                <Typography sx={{ fontWeight: 600, mb: 1.5 }}>
                                    סוג ייצוא (ניתן לבחור שילוב)
                                </Typography>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={!!pkudaExportOptions?.includeIncomes}
                                            onChange={(e) => refreshPkudaExportPreview({
                                                ...pkudaExportOptions,
                                                includeIncomes: e.target.checked
                                            })}
                                        />
                                    }
                                    label="הכנסות"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={!!pkudaExportOptions?.includeExpenses}
                                            onChange={(e) => refreshPkudaExportPreview({
                                                ...pkudaExportOptions,
                                                includeExpenses: e.target.checked
                                            })}
                                        />
                                    }
                                    label="הוצאות"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={!!pkudaExportOptions?.includeJournalEntries}
                                            onChange={(e) => refreshPkudaExportPreview({
                                                ...pkudaExportOptions,
                                                includeJournalEntries: e.target.checked
                                            })}
                                        />
                                    }
                                    label="פקודות יומן"
                                />
                            </Box>

                            {/* Preview Information */}
                            <Box sx={{ 
                                p: 3, 
                                backgroundColor: pkudaExportPreviewData.totalRecords > 0 ? '#d4edda' : '#fff3cd', 
                                borderRadius: '8px',
                                border: pkudaExportPreviewData.totalRecords > 0 ? '1px solid #28a745' : '1px solid #ffc107',
                                mb: 3
                            }}>
                                <Typography variant="h6" sx={{ 
                                    color: pkudaExportPreviewData.totalRecords > 0 ? '#155724' : '#856404', 
                                    mb: 2,
                                    fontWeight: 600
                                }}>
                                    {pkudaExportPreviewData.totalRecords > 0 ? '✓ מסמכים מוכנים לייצוא' : '⚠ אזהרה'}
                                </Typography>
                                
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                                    {pkudaExportOptions?.includeIncomes && (
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Typography sx={{ fontWeight: 500 }}>הכנסות:</Typography>
                                            <Typography sx={{ fontWeight: 700, fontSize: '18px' }}>
                                                {pkudaExportPreviewData.totalIncomes}
                                            </Typography>
                                        </Box>
                                    )}
                                    {pkudaExportOptions?.includeExpenses && (
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Typography sx={{ fontWeight: 500 }}>הוצאות:</Typography>
                                            <Typography sx={{ fontWeight: 700, fontSize: '18px' }}>
                                                {pkudaExportPreviewData.totalExpenses}
                                            </Typography>
                                        </Box>
                                    )}
                                    {pkudaExportOptions?.includeJournalEntries && (
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Typography sx={{ fontWeight: 500 }}>פקודות יומן:</Typography>
                                            <Typography sx={{ fontWeight: 700, fontSize: '18px' }}>
                                                {pkudaExportPreviewData.totalJournalEntries}
                                            </Typography>
                                        </Box>
                                    )}
                                    <Box sx={{ 
                                        display: 'flex', 
                                        justifyContent: 'space-between', 
                                        alignItems: 'center',
                                        pt: 1,
                                        mt: 1,
                                        borderTop: '2px solid rgba(0,0,0,0.1)'
                                    }}>
                                        <Typography sx={{ fontWeight: 700 }}>סה"כ רשומות:</Typography>
                                        <Typography sx={{ fontWeight: 700, fontSize: '20px', color: '#304FFF' }}>
                                            {pkudaExportPreviewData.totalRecords}
                                        </Typography>
                                    </Box>
                                </Box>

                                <Box sx={{ 
                                    mt: 2.5, 
                                    pt: 2.5, 
                                    borderTop: '1px solid rgba(0,0,0,0.1)'
                                }}>
                                    <Typography sx={{ 
                                        fontSize: '14px', 
                                        color: pkudaExportPreviewData.totalRecords > 0 ? '#155724' : '#856404',
                                        fontWeight: 500
                                    }}>
                                        {pkudaExportPreviewData.message}
                                    </Typography>
                                </Box>
                            </Box>

                            {/* Action Buttons */}
                            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                                <Button 
                                    variant="outlined" 
                                    onClick={() => setShowPkudaExportPreview(false)}
                                    sx={{ minWidth: '120px' }}
                                >
                                    {t('Cancel') || 'ביטול'}
                                </Button>
                                <Button 
                                    variant="contained" 
                                    color="success"
                                    onClick={confirmPkudaExport}
                                    disabled={
                                        pkudaExportPreviewData.totalRecords === 0
                                        || (!pkudaExportOptions?.includeIncomes
                                            && !pkudaExportOptions?.includeExpenses
                                            && !pkudaExportOptions?.includeJournalEntries)
                                    }
                                    sx={{ minWidth: '120px' }}
                                >
                                    {t('ConfirmExport') || 'אישור וייצוא'}
                                </Button>
                            </Box>
                        </div>
                    </div>
                </div>
            )}

            {showMoveinExportPreview && moveinExportPreviewData && (
                <div className="download-modal-overlay" onClick={() => setShowMoveinExportPreview(false)}>
                    <div className="download-modal" onClick={(e) => e.stopPropagation()}>
                        <div className={`download-modal-content ${direction}`} style={{ position: 'relative', maxWidth: '900px', width: '90vw', maxHeight: '85vh', overflow: 'auto' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                                <h4 className="report-title">{t('MoveinDatExportPreviewTitle') || 'תצוגה מקדימה - ייצוא Movein.dat'}</h4>
                                <IconButton
                                    className="client-back-icon"
                                    onClick={() => setShowMoveinExportPreview(false)}
                                    sx={{ padding: '4px' }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </div>

                            {/* Summary counts */}
                            <Box sx={{
                                p: 2.5,
                                backgroundColor: (moveinExportPreviewData.totalRecords || 0) > 0 ? '#d4edda' : '#fff3cd',
                                borderRadius: '8px',
                                border: (moveinExportPreviewData.totalRecords || 0) > 0 ? '1px solid #28a745' : '1px solid #ffc107',
                                mb: 2.5
                            }}>
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: 'space-between' }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                        <Typography sx={{ fontSize: '12px', color: '#555' }}>{t('Incomes') || 'הכנסות'}</Typography>
                                        <Typography sx={{ fontWeight: 700, fontSize: '18px' }}>{moveinExportPreviewData.totalIncomes ?? 0}</Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                        <Typography sx={{ fontSize: '12px', color: '#555' }}>{t('Expenses') || 'הוצאות'}</Typography>
                                        <Typography sx={{ fontWeight: 700, fontSize: '18px' }}>{moveinExportPreviewData.totalExpenses ?? 0}</Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                        <Typography sx={{ fontSize: '12px', color: '#555' }}>{t('JournalEntries') || 'פקודות יומן'}</Typography>
                                        <Typography sx={{ fontWeight: 700, fontSize: '18px' }}>{moveinExportPreviewData.totalJournalEntries ?? 0}</Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                        <Typography sx={{ fontSize: '12px', color: '#555' }}>{t('PaymentAcceptances') || 'קבלות'}</Typography>
                                        <Typography sx={{ fontWeight: 700, fontSize: '18px' }}>{moveinExportPreviewData.totalPaymentAcceptances ?? 0}</Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                        <Typography sx={{ fontSize: '12px', color: '#555' }}>{t('TotalRecords') || 'סה"כ רשומות'}</Typography>
                                        <Typography sx={{ fontWeight: 700, fontSize: '20px', color: '#304FFF' }}>{moveinExportPreviewData.totalRecords ?? 0}</Typography>
                                    </Box>
                                </Box>
                                {moveinExportPreviewData.message && (
                                    <Typography sx={{ mt: 1.5, fontSize: '13px', color: '#444' }}>
                                        {moveinExportPreviewData.message}
                                    </Typography>
                                )}
                            </Box>

                            {/* SortCode -> MovementCode mapping editor */}
                            {Array.isArray(moveinExportPreviewData.uniqueSortCodeNames) && moveinExportPreviewData.uniqueSortCodeNames.length > 0 && (
                                <Box sx={{ mb: 2.5 }}>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                                        {t('SortCodeMappings') || 'מיפוי סוגי תנועה (קוד מקסימום 3 תווים)'}
                                    </Typography>
                                    <Typography sx={{ fontSize: '12px', color: '#666', mb: 1 }}>
                                        {t('SortCodeMappingsHelp') || 'בחר עבור כל שם קוד מיון את הקוד הקצר שיופיע בעמודת סוג תנועה בקובץ המיוצא. ערכים ארוכים מ-3 תווים ייחתכו.'}
                                    </Typography>
                                    <TableContainer component={Paper} sx={{ maxHeight: 240 }}>
                                        <Table size="small" stickyHeader>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ fontWeight: 700 }}>{t('OurSortCodeName') || 'שם קוד מיון (שלנו)'}</TableCell>
                                                    <TableCell sx={{ fontWeight: 700, width: '200px' }}>{t('ExportedCode') || 'קוד לייצוא'}</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {moveinExportPreviewData.uniqueSortCodeNames.map((name) => {
                                                    const key = name ?? '';
                                                    const value = (moveinSortCodeMappings && moveinSortCodeMappings[key]) ?? '';
                                                    return (
                                                        <TableRow key={`movein-map-${key}`}>
                                                            <TableCell>{key || (t('NoSortCode') || '— ללא קוד מיון —')}</TableCell>
                                                            <TableCell>
                                                                <TextField
                                                                    size="small"
                                                                    value={value}
                                                                    inputProps={{ maxLength: 3 }}
                                                                    onChange={(e) => {
                                                                        const next = { ...(moveinSortCodeMappings || {}) };
                                                                        next[key] = (e.target.value ?? '').slice(0, 3);
                                                                        setMoveinSortCodeMappings(next);
                                                                    }}
                                                                    fullWidth
                                                                />
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            )}

                            {/* Records preview */}
                            {Array.isArray(moveinExportPreviewData.records) && moveinExportPreviewData.records.length > 0 && (
                                <Box sx={{ mb: 2.5 }}>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                                        {t('RecordsPreview') || 'תצוגה מקדימה של הרשומות'}
                                    </Typography>
                                    <TableContainer component={Paper} sx={{ maxHeight: 300 }}>
                                        <Table size="small" stickyHeader>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ fontWeight: 700 }}>{t('Source') || 'מקור'}</TableCell>
                                                    <TableCell sx={{ fontWeight: 700 }}>{t('SortCodeName') || 'שם קוד מיון'}</TableCell>
                                                    <TableCell sx={{ fontWeight: 700 }}>{t('Date') || 'תאריך'}</TableCell>
                                                    <TableCell sx={{ fontWeight: 700 }}>{t('DebitAccount') || 'חובה'}</TableCell>
                                                    <TableCell sx={{ fontWeight: 700 }}>{t('CreditAccount') || 'זכות'}</TableCell>
                                                    <TableCell sx={{ fontWeight: 700, textAlign: 'right' }}>{t('Amount') || 'סכום'}</TableCell>
                                                    <TableCell sx={{ fontWeight: 700 }}>{t('Reference') || 'אסמכתא'}</TableCell>
                                                    <TableCell sx={{ fontWeight: 700 }}>{t('Description') || 'פרטים'}</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {moveinExportPreviewData.records.slice(0, 500).map((r, idx) => {
                                                    const rawDate = r.referenceDate ?? r.ReferenceDate ?? '';
                                                    let formattedDate = '';
                                                    try {
                                                        if (rawDate) {
                                                            const d = new Date(rawDate);
                                                            if (!isNaN(d.getTime())) {
                                                                formattedDate = d.toLocaleDateString();
                                                            } else {
                                                                formattedDate = String(rawDate);
                                                            }
                                                        }
                                                    } catch (e) {
                                                        formattedDate = String(rawDate);
                                                    }
                                                    const rawSource = r.source ?? r.Source ?? '';
                                                    const sourceLabel = rawSource ? (t(rawSource) || rawSource) : '';
                                                    return (
                                                        <TableRow key={`movein-row-${idx}`}>
                                                            <TableCell>{sourceLabel}</TableCell>
                                                            <TableCell>{r.sortCodeName ?? r.SortCodeName ?? ''}</TableCell>
                                                            <TableCell>{formattedDate}</TableCell>
                                                            <TableCell>{r.debitAccount ?? r.DebitAccount ?? ''}</TableCell>
                                                            <TableCell>{r.creditAccount ?? r.CreditAccount ?? ''}</TableCell>
                                                            <TableCell sx={{ textAlign: 'right' }}>
                                                                {Number(r.amount ?? r.Amount ?? 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                            </TableCell>
                                                            <TableCell>{r.reference1 ?? r.Reference1 ?? ''}</TableCell>
                                                            <TableCell sx={{ maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                                {r.details ?? r.Details ?? ''}
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    {moveinExportPreviewData.records.length > 500 && (
                                        <Typography sx={{ mt: 1, fontSize: '12px', color: '#888' }}>
                                            {(t('PreviewTruncatedHint') || 'מוצגות 500 הרשומות הראשונות. הקובץ המיוצא יכלול את כולן.')}
                                        </Typography>
                                    )}
                                </Box>
                            )}

                            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                                <Button
                                    variant="outlined"
                                    onClick={() => setShowMoveinExportPreview(false)}
                                    sx={{ minWidth: '120px' }}
                                >
                                    {t('Cancel') || 'ביטול'}
                                </Button>
                                <Button
                                    variant="contained"
                                    color="success"
                                    onClick={confirmMoveinExport}
                                    disabled={(moveinExportPreviewData.totalRecords ?? 0) === 0}
                                    sx={{ minWidth: '120px' }}
                                >
                                    {t('ConfirmExport') || 'אישור וייצוא'}
                                </Button>
                            </Box>
                        </div>
                    </div>
                </div>
            )}

            {/* Account Cards PKUDA Export Preview Modal */}
            <AccountCardPkudaExportModal
                open={showAccountCardExportPreview}
                onClose={() => setShowAccountCardExportPreview(false)}
                previewData={accountCardExportPreviewData}
                editableAccountCards={editableAccountCards}
                setEditableAccountCards={setEditableAccountCards}
                onConfirmExport={confirmAccountCardExport}
                direction={direction}
                t={t}
            />

                        {/* PCN Documents Check Modal */}
            <PCNChecksModal
                open={showPCNChecksModal}
                onClose={() => setShowPCNChecksModal(false)}
                direction={direction}
                t={t}
                pcnHighConfirmationDocs={pcnHighConfirmationDocs}
                pcnDocumentsNeedingAllocation={pcnDocumentsNeedingAllocation}
                pcnDocumentsWithoutReference={pcnDocumentsWithoutReference}
                pcnDocumentsOutOfRange={pcnDocumentsOutOfRange}
                pcnReportDetails={pcnReportDetails}
                onDocumentClick={handleDocumentRowClickInDownloadImportModals}
                setShowPCNModal={setShowPCNModal}
                handlePCNDownload={handlePCNDownload}
                startDate={isDateRange ? startDate : date}
                endDate={isDateRange ? endDate : date}
                caseId={client?.caseId}
                token={token}
                includeStornoChecks={pcnIncludeStornoChecks}
                sortCodeIdOptions={sortCodeOptions}
                accountCardOptions={accountCardOptions}
            />

            {/* PCN Storno Checks Modal */}
            <PCNModal
                open={showPCNModal}
                onClose={() => setShowPCNModal(false)}
                direction={direction}
                isDateRange={isDateRange}
                setIsDateRange={setIsDateRange}
                date={date}
                setDate={setDate}
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
                CustomMonthDatePicker={CustomMonthDatePicker}
                pcnIncludeStornoChecks={pcnIncludeStornoChecks}
                setPcnIncludeStornoChecks={setPcnIncludeStornoChecks}
                pcnChecksLoading={pcnChecksLoading}
                handlePCNChecks={handlePCNChecksWithModalDates}
                handlePCNDownload={handlePCNDownloadWithModalDates}
                t={t}
            />

            {/* Tutorial Videos Modal */}
            <TutorialVideosModal
                open={showTutorialVideosModal}
                onClose={() => setShowTutorialVideosModal(false)}
                direction={direction}
            />

            {/* Sumit Account Cards Import Modal */}
            <SumitAccountCardsImportModal
                open={showSumitAccountCardsModal}
                onClose={() => setShowSumitAccountCardsModal(false)}
                previewSumitAccountCards={previewSumitAccountCards}
                commitSumitAccountCards={commitSumitAccountCards}
                createMissingPalCode={createMissingPalCode}
                direction={direction}
                t={t}
                palCodeCategoryOptions={palCodeCategoryOptions}
                palCodes={palCodes || []}
                Constants={Constants}
                user={user || {}}
            />

            {/* Sumit Journal Import Modal */}
            <SumitJournalImportModal
                open={showSumitJournalModal}
                onClose={() => setShowSumitJournalModal(false)}
                previewSumitJournal={previewSumitJournal}
                commitSumitJournal={commitSumitJournal}
                createMissingSortCodes={createMissingSortCodes}
                createMissingSortCodeCategory={createMissingSortCodeCategory}
                direction={direction}
                t={t}
                formattedSortCodeVatType={formattedSortCodeVatType}
                formattedSortCodesGroupNamesOptions={formattedSortCodesGroupNamesOptions}
                Constants={Constants}
                client={client}
                token={token}
                palCodes={palCodes || []}
                accountCardOptions={accountCardOptions}
                fetchEnums={fetchEnums}
                setLoading={setLoading}
                user={user}
                setAccountCardOptions={setAccountCardOptions}
            />

            {/* Finbot Account Cards Import Modal */}
            <FinbotAccountCardsImportModal
                open={showFinbotAccountCardsModal}
                onClose={() => setShowFinbotAccountCardsModal(false)}
                previewFinbotAccountCards={previewFinbotAccountCards}
                commitFinbotAccountCards={commitFinbotAccountCards}
                previewFinbotAccountCardsApi={previewFinbotAccountCardsApi}
                commitFinbotAccountCardsApi={commitFinbotAccountCardsApi}
                fetchFinbotClients={fetchFinbotClients}
                createMissingPalCode={createMissingPalCode}
                direction={direction}
                t={t}
                palCodeCategoryOptions={palCodeCategoryOptions}
                palCodes={palCodes || []}
                Constants={Constants}
                client={client}
                user={user || {}}
            />

            {/* Finbot Journal Import Modal */}
            <FinbotJournalImportModal
                open={showFinbotJournalModal}
                onClose={() => setShowFinbotJournalModal(false)}
                previewFinbotJournal={previewFinbotJournal}
                commitFinbotJournal={commitFinbotJournal}
                previewFinbotJournalApi={previewFinbotJournalApi}
                commitFinbotJournalApi={commitFinbotJournalApi}
                fetchFinbotClients={fetchFinbotClients}
                createMissingSortCodes={createMissingSortCodes}
                direction={direction}
                t={t}
                formattedSortCodeVatType={formattedSortCodeVatType}
                formattedSortCodesGroupNamesOptions={formattedSortCodesGroupNamesOptions}
                Constants={Constants}
                client={client}
                token={token}
                palCodes={palCodes || []}
                accountCardOptions={accountCardOptions}
                fetchEnums={fetchEnums}
                setLoading={setLoading}
                user={user}
                setAccountCardOptions={setAccountCardOptions}
            />

            {/* Paperless Import Modal — one preview/commit for both cards and journal entries */}
            <PaperlessImportModal
                open={showPaperlessModal}
                onClose={() => setShowPaperlessModal(false)}
                previewPaperlessApi={previewPaperlessApi}
                commitPaperlessApi={commitPaperlessApi}
                fetchPaperlessUsers={fetchPaperlessUsers}
                createMissingSortCodes={createMissingSortCodes}
                createMissingPalCode={createMissingPalCode}
                direction={direction}
                t={t}
                formattedSortCodeVatType={formattedSortCodeVatType}
                formattedSortCodesGroupNamesOptions={formattedSortCodesGroupNamesOptions}
                palCodeCategoryOptions={palCodeCategoryOptions || []}
                palCodes={palCodes || []}
                accountCardOptions={accountCardOptions}
                client={client}
                user={user || {}}
            />

            {/* Ravginit (RAVGONIT .26) Journal Import Modal — also creates missing account cards */}
            <RavginitJournalImportModal
                open={showRavginitJournalModal}
                onClose={() => setShowRavginitJournalModal(false)}
                previewRavginitJournal={previewRavginitJournal}
                commitRavginitJournal={commitRavginitJournal}
                createMissingSortCodes={createMissingSortCodes}
                direction={direction}
                t={t}
                formattedSortCodeVatType={formattedSortCodeVatType}
                formattedSortCodesGroupNamesOptions={formattedSortCodesGroupNamesOptions}
                client={client}
                token={token}
                palCodes={palCodes || []}
                accountCardOptions={accountCardOptions}
                fetchEnums={fetchEnums}
                setLoading={setLoading}
                user={user}
                setAccountCardOptions={setAccountCardOptions}
            />

            {/* Uniform file (BKMVDATA.txt) Journal Import Modal — also creates missing account cards */}
            <BmkvdJournalImportModal
                open={showBmkvdJournalModal}
                onClose={() => setShowBmkvdJournalModal(false)}
                previewBmkvdJournal={previewBmkvdJournal}
                commitBmkvdJournal={commitBmkvdJournal}
                createMissingSortCodes={createMissingSortCodes}
                createMissingPalCode={createMissingPalCode}
                direction={direction}
                t={t}
                formattedSortCodeVatType={formattedSortCodeVatType}
                formattedSortCodesGroupNamesOptions={formattedSortCodesGroupNamesOptions}
                palCodeCategoryOptions={palCodeCategoryOptions || []}
                palCodes={palCodes || []}
                sortCodeIdOptions={sortCodeOptions}
                user={user || {}}
            />

            <AtzmaitBackupImportModal
                open={showAtzmaitBackupModal}
                onClose={() => setShowAtzmaitBackupModal(false)}
                accountantId={client?.accountantId}
                token={token}
                caseId={client?.caseId}
                clientName={client?.name}
            />

            <RivhitBackupImportModal
                open={showRivhitBackupModal}
                onClose={() => setShowRivhitBackupModal(false)}
                accountantId={client?.accountantId}
                token={token}
                caseId={client?.caseId}
                clientName={client?.name}
                clientAccountManagement={client?.accountManagement}
            />

            {/* Webenefit Journal Import Modal */}
            <WebenefitJournalImportModal
                open={showWebenefitJournalModal}
                onClose={() => setShowWebenefitJournalModal(false)}
                previewWebenefitJournal={previewWebenefitJournal}
                commitWebenefitJournal={commitWebenefitJournal}
                createMissingSortCodes={createMissingSortCodes}
                direction={direction}
                t={t}
                formattedSortCodeVatType={formattedSortCodeVatType}
                formattedSortCodesGroupNamesOptions={formattedSortCodesGroupNamesOptions}
            />

            {/* קוד בינה Account Cards Import Modal */}
            <KodBenaAccountCardsImportModal
                open={showKodBenaAccountCardsModal}
                onClose={() => setShowKodBenaAccountCardsModal(false)}
                previewKodBenaAccountCards={previewKodBenaAccountCards}
                commitKodBenaAccountCards={commitKodBenaAccountCards}
                createMissingPalCode={createMissingPalCode}
                direction={direction}
                t={t}
                palCodeCategoryOptions={palCodeCategoryOptions}
                palCodes={palCodes || []}
                Constants={Constants}
                user={user}
            />

            {/* קוד בינה Journal Import Modal */}
            <KodBenaJournalImportModal
                open={showKodBenaJournalModal}
                onClose={() => setShowKodBenaJournalModal(false)}
                previewKodBenaJournal={previewKodBenaJournal}
                commitKodBenaJournal={commitKodBenaJournal}
                createMissingSortCodes={createMissingSortCodes}
                direction={direction}
                t={t}
                formattedSortCodeVatType={formattedSortCodeVatType}
                formattedSortCodesGroupNamesOptions={formattedSortCodesGroupNamesOptions}
                Constants={Constants}
                client={client}
                token={token}
                palCodes={palCodes || []}
                accountCardOptions={accountCardOptions}
                fetchEnums={fetchEnums}
                setLoading={setLoading}
                user={user}
                setAccountCardOptions={setAccountCardOptions}
            />

            {/* Taiodet Account Cards Import Modal */}
            <TaiodetAccountCardsImportModal
                open={showTaiodetAccountCardsModal}
                onClose={() => setShowTaiodetAccountCardsModal(false)}
                previewTaiodetAccountCards={previewTaiodetAccountCards}
                commitTaiodetAccountCards={commitTaiodetAccountCards}
                createMissingPalCode={createMissingPalCode}
                direction={direction}
                t={t}
                palCodeCategoryOptions={palCodeCategoryOptions}
                palCodes={palCodes || []}
                Constants={Constants}
                user={user || {}}
            />

            {/* Taiodet Journal Import Modal */}
            <TaiodetJournalImportModal
                open={showTaiodetJournalModal}
                onClose={() => setShowTaiodetJournalModal(false)}
                previewTaiodetJournal={previewTaiodetJournal}
                commitTaiodetJournal={commitTaiodetJournal}
                direction={direction}
                t={t}
                client={client}
                token={token}
                palCodes={palCodes || []}
                accountCardOptions={accountCardOptions}
                fetchEnums={fetchEnums}
                setLoading={setLoading}
                user={user}
                setAccountCardOptions={setAccountCardOptions}
                CustomMonthDatePicker={CustomMonthDatePicker}
            />

            {/* Priority Account Cards Import Modal */}
            <PriorityAccountCardsImportModal
                open={showPriorityAccountCardsModal}
                onClose={() => setShowPriorityAccountCardsModal(false)}
                previewPriorityAccountCards={previewPriorityAccountCards}
                commitPriorityAccountCards={commitPriorityAccountCards}
                createMissingPalCode={createMissingPalCode}
                direction={direction}
                t={t}
                palCodeCategoryOptions={palCodeCategoryOptions}
                palCodes={palCodes || []}
                Constants={Constants}
                user={user || {}}
            />

            {/* Priority Journal Import Modal */}
            <PriorityJournalImportModal
                open={showPriorityJournalModal}
                onClose={() => setShowPriorityJournalModal(false)}
                previewPriorityJournal={previewPriorityJournal}
                commitPriorityJournal={commitPriorityJournal}
                createMissingSortCodes={createMissingSortCodes}
                direction={direction}
                t={t}
                formattedSortCodeVatType={formattedSortCodeVatType}
                formattedSortCodesGroupNamesOptions={formattedSortCodesGroupNamesOptions}
                Constants={Constants}
                client={client}
                token={token}
                palCodes={palCodes || []}
                accountCardOptions={accountCardOptions}
                fetchEnums={fetchEnums}
                setLoading={setLoading}
                user={user}
                setAccountCardOptions={setAccountCardOptions}
            />

            {/* Priority Opening Balance Import Modal */}
            <PriorityOpeningBalanceImportModal
                open={showPriorityOpeningBalanceModal}
                onClose={() => setShowPriorityOpeningBalanceModal(false)}
                previewPriorityOpeningBalance={previewPriorityOpeningBalance}
                commitPriorityOpeningBalance={commitPriorityOpeningBalance}
                direction={direction}
                t={t}
            />

            {/* Rivhit CSV V2 Import Modal */}
            <RivhitCsvImportModal
                open={showRivhitCsvV2Modal}
                onClose={() => setShowRivhitCsvV2Modal(false)}
                previewRivhitCsv={previewRivhitCsvV2}
                commitRivhitCsv={commitRivhitCsvV2}
                createMissingPalCode={createMissingPalCode}
                direction={direction}
                t={t}
                palCodeCategoryOptions={palCodeCategoryOptions || []}
                palCodes={palCodes || []}
                Constants={Constants}
                user={user || {}}
            />

            {/* אינדקס חשבונות (Excel) — RAVGONIT and NIHULIT chart-of-accounts listings */}
            <AccountIndexImportModal
                open={showRavginitAccountIndexModal}
                onClose={() => setShowRavginitAccountIndexModal(false)}
                title={t('ImportRavginitAccountIndex') || 'רבגונית - אינדקס חשבונות (Excel)'}
                formatHint={t('RavginitAccountIndexFormat')
                    || 'עמודות: מספר חשבון, שם חשבון, תאור סיווג (הכנסה/הוצאה). הסיווג נטען כחשבון ראשי.'}
                previewAccountIndex={previewRavginitAccountIndex}
                commitAccountIndex={commitRavginitAccountIndex}
                createMissingPalCode={createMissingPalCode}
                direction={direction}
                t={t}
                palCodeCategoryOptions={palCodeCategoryOptions || []}
                palCodes={palCodes || []}
                Constants={Constants}
                user={user || {}}
            />

            <AccountIndexImportModal
                open={showNihulitAccountIndexModal}
                onClose={() => setShowNihulitAccountIndexModal(false)}
                title={t('ImportNihulitAccountIndex') || 'ניהולית - אינדקס חשבונות (Excel)'}
                formatHint={t('NihulitAccountIndexFormat')
                    || 'עמודות: חשבון, שם חשבון, סעיף מאזני, מספר תיק מע"מ. הסעיף המאזני נטען כחשבון ראשי.'}
                previewAccountIndex={previewNihulitAccountIndex}
                commitAccountIndex={commitNihulitAccountIndex}
                createMissingPalCode={createMissingPalCode}
                direction={direction}
                t={t}
                palCodeCategoryOptions={palCodeCategoryOptions || []}
                palCodes={palCodes || []}
                Constants={Constants}
                user={user || {}}
            />

            <RamplusAccountCardsImportModal
                open={showRamplusAccountCardsModal}
                onClose={() => setShowRamplusAccountCardsModal(false)}
                previewRamplusAccountCards={previewRamplusAccountCards}
                commitRamplusAccountCards={commitRamplusAccountCards}
                createMissingPalCode={createMissingPalCode}
                direction={direction}
                t={t}
                palCodeCategoryOptions={palCodeCategoryOptions || []}
                palCodes={palCodes || []}
                Constants={Constants}
                user={user || {}}
            />

            <RamplusJournalImportModal
                open={showRamplusJournalModal}
                onClose={() => setShowRamplusJournalModal(false)}
                previewRamplusJournal={previewRamplusJournal}
                commitRamplusJournal={commitRamplusJournal}
                createMissingSortCodes={createMissingSortCodes}
                direction={direction}
                t={t}
                formattedSortCodeVatType={formattedSortCodeVatType}
                formattedSortCodesGroupNamesOptions={formattedSortCodesGroupNamesOptions}
                client={client}
                token={token}
                palCodes={palCodes || []}
                accountCardOptions={accountCardOptions}
                setAccountCardOptions={setAccountCardOptions}
                sortCodeOptions={sortCodeOptions}
                fetchEnums={fetchEnums}
                setLoading={setLoading}
                user={user}
            />

            <RamplusClosingBalanceImportModal
                open={showRamplusClosingBalanceModal}
                onClose={() => setShowRamplusClosingBalanceModal(false)}
                previewRamplusClosingBalance={previewRamplusClosingBalance}
                commitRamplusClosingBalance={commitRamplusClosingBalance}
                direction={direction}
                t={t}
            />

            {/* BMKVD (Uniform File) export */}
            <DownloadUniformFile
                open={showUniformFileModal}
                onClose={() => setShowUniformFileModal(false)}
                client={client}
                token={token}
                direction={direction}
            />
           
        </>
    );
});

export default DownloadImportModals;
